/**
 * Archivo de localización: PT
 * Míster 11 - Sistema de Localización Canónico
 */

export const pt = {
  "ach.biweekly_fit.desc": "Registre ou supere sua melhor marca nos testes físicos da equipe.",
  "ach.biweekly_fit.name": "Evolução Física",
  "ach.biweekly_iron.desc": "100% de presença durante 14 dias consecutivos.",
  "ach.biweekly_iron.name": "Jogador de Ferro",
  "ach.biweekly_self_care.desc": "Envie seu check-in de bem-estar em pelo menos 80% dos dias.",
  "ach.biweekly_self_care.name": "Hábito Saudável",
  "ach.biweekly_strong_mind.desc": "Realize 3 testes psicológicos de enfrentamento ou força mental.",
  "ach.biweekly_strong_mind.name": "Resiliência de Competição",
  "ach.biweekly_teammate.desc": "Confirme sua presença (RSVP) em todos os eventos com antecedência.",
  "ach.biweekly_teammate.name": "Compromisso com o Grupo",
  "ach.gold_cone_memory.desc": "Lembre-se e reproduza uma sequência de pelo menos 6 cones na Memória de Cones.",
  "ach.gold_cone_memory.name": "Memória de Campeonato",
  "ach.gold_impulse_brake.desc": "Alcance 90% ou mais de precisão no jogo Freio Impulsivo.",
  "ach.gold_impulse_brake.name": "Freio de Ouro",
  "ach.gold_tactical_eye.desc": "Acerte 5 de 5 no Olho Tático encontrando o companheiro livre.",
  "ach.gold_tactical_eye.name": "Olho de Falcão",
  "ach.season_analyst.desc": "Complete todos os questionários e avaliações do catálogo.",
  "ach.season_analyst.name": "Mestre Tático e Psicológico",
  "ach.season_assist.desc": "Dê assistências decisivas para gol aos seus companheiros.",
  "ach.season_assist.name": "Motor da Equipe",
  "ach.season_captain.desc": "100% de presença em treinos e partidas durante um mês completo.",
  "ach.season_captain.name": "Espírito de Capitão",
  "ach.season_mental_squad.desc": "Conquista coletiva: o time acumula 20 ou mais sessões cognitivas concluídas.",
  "ach.season_mental_squad.name": "Equipe Mental",
  "ach.season_scorer.desc": "Atinja a meta de gols marcados em competições oficiais.",
  "ach.season_scorer.name": "Artilheiro da Temporada",
  "ach.season_unstoppable.desc": "Mantenha uma sequência ativa de 21 dias de constância esportiva.",
  "ach.season_unstoppable.name": "Sequência Imparável",
  "ach.season_veteran.desc": "Participe ou seja convocado para pelo menos 80% das partidas do ano.",
  "ach.season_veteran.name": "Veterano da Temporada",
  "ach.weekly_attentive.desc": "Confira os detalhes da próxima partida ou treino antes da convocação.",
  "ach.weekly_attentive.name": "Sempre Atento",
  "ach.weekly_committed.desc": "Complete os exercícios do seu plano individual atribuído.",
  "ach.weekly_committed.name": "Trabalho Invisível",
  "ach.weekly_mind_active.desc": "Complete pelo menos 3 sessões de treino cognitivo ou desafios esta semana.",
  "ach.weekly_mind_active.name": "Mente Ativa",
  "ach.weekly_perfect_week.desc": "Compareça a 100% das sessões de treino programadas para esta semana.",
  "ach.weekly_perfect_week.name": "Semana Perfeita",
  "ach.weekly_scholar.desc": "Complete pelo menos 1 teste psicológico ou avaliação no portal.",
  "ach.weekly_scholar.name": "Mente Forte",
  "ach.weekly_wellness.desc": "Registre seu descanso e dores nos dias de treino.",
  "ach.weekly_wellness.name": "Check-in de Saúde",
  "ach.weekly_zen.desc": "Complete a Respiração 4-4 em pelo menos 3 dias diferentes durante a semana.",
  "ach.weekly_zen.name": "Zen",
  "achievements.toast_unlocked": "Conquista desbloqueada: {name}! (+{xp} XP)",
  "admin.account_deleted": "Tu conta de entrenador e dados han sido eliminados correctamente.",
  "admin.ai.desc": "Configure a chave de API do Groq para que a IA Generativa funcione em todos os dispositivos (incluindo o APK do tablet sem recompilar).",
  "admin.ai.keyLabel": "Chave de API do Groq (gsk_...)",
  "admin.ai.saveKey": "SALVAR CHAVE",
  "admin.ai.title": "Configuração de IA (Groq)",
  "admin.already_latest": "✅ Você já tem a versão mais recente instalada (v{version}).",
  "admin.apk.desc": "Instale o Mister11 diretamente no seu tablet Android",
  "admin.apk.downloadBtn": "BAIXAR APK",
  "admin.apk.instructions": "Apenas para Android · Habilite 'Fontes desconhecidas' nas Configurações do sistema antes de instalar",
  "admin.apk.title": "Aplicativo Android (APK)",
  "admin.apk_download_done": "✅ Baixar complete. Find the file in your Downloads folder and install it.",
  "admin.apk_download_fallback": "⚠️ Descarga directa fallida. Abriendo enlace alternativo...",
  "admin.apk_download_start": "⬇️ Iniciando descarga do APK...",
  "admin.backup_error": "Error al generar a copia de segurança.",
  "admin.groq_api_error": "Error al salvar a clave API en Firestore.",
  "admin.groq_api_saved": "Chave API da Groq salva com sucesso!",
  "admin.lang.title": "Idioma do Sistema",
  "admin.manageSubAndroidMsg": "Gerencie sua assinatura em mister11.app",
  "admin.match_not_found": "Partida não encontrada.",
  "admin.no_active_team": "Nenhum time ativo selecionado.",
  "admin.no_players": "Nenhum jogador no time ativo.",
  "admin.notif.title": "Notificações",
  "admin.pref.checkUpdates": "Buscar atualizações",
  "admin.pref.checking": "Verificando...",
  "admin.pref.darkMode": "Modo Escuro",
  "admin.pref.reminders": "Lembretes de Sessão",
  "admin.pref.remindersDescApk": "Disponível no aplicativo Android (APK).",
  "admin.pref.remindersDescNative": "Você receberá uma notificação 1 hora antes de cada sessão de treino.",
  "admin.pref.systemLang": "IDIOMA DO SISTEMA",
  "admin.pref.title": "Preferências",
  "admin.pref.version": "Versão atual do aplicativo",
  "admin.profile_error": "Error al salvar perfil.",
  "admin.profile_synced": "Perfil de entrenador sincronizado en todo ou sistema.",
  "admin.report_error": "Error al generar ou informe global.",
  "admin.section.equipos": "Time Management",
  "admin.select_match_first": "Selecciona um partida primero.",
  "admin.select_session_first": "Selecione uma sessão primeiro.",
  "admin.select_team_first": "Selecione uma equipe primeiro.",
  "admin.session_not_found": "Sessão not found.",
  "admin.settings.category": "CATEGORIA",
  "admin.settings.coachProfile": "Perfil do Treinador",
  "admin.settings.cookies": "Cookies",
  "admin.settings.copyConsentBtn": "🔗 Copiar Link de Consentimento Digital",
  "admin.settings.deleteAccountGdpr": "Excluir Conta e Dados (LGPD/GDPR)",
  "admin.settings.downloadConsentBtn": "Baixar Consentimento dos Pais (Para impressão)",
  "admin.settings.fullName": "Nome Completo",
  "admin.settings.inviteStaffBtn": "Copiar / Compartilhar Link para Convidar Treinadores",
  "admin.settings.legalDesc": "Baixe modelos legais obrigatórios e gerencie o consentimento informado para os pais dos seus jogadores menores de idade.",
  "admin.settings.legalTitle": "Centro Legal e Consentimentos",
  "admin.settings.manageStaffBtn": "Ver e Gerenciar Toda a Comissão Técnica",
  "admin.settings.primaryColor": "COR PRINCIPAL",
  "admin.settings.privacy": "Privacidade",
  "admin.settings.roleAnalyst": "Analista Tático",
  "admin.settings.roleAssistant3": "Auxiliar / 3º Treinador",
  "admin.settings.roleAssistantCoach": "Segundo Treinador",
  "admin.settings.roleFitnessCoach": "Preparador Físico",
  "admin.settings.roleHeadCoach": "Treinador Principal (Admin)",
  "admin.settings.rolePhysio": "Fisioterapeuta / Médico",
  "admin.settings.rolePlayer": "Jogador",
  "admin.settings.roleSpecialty": "Função / Especialidade na Equipe",
  "admin.settings.saveIdentity": "SALVAR Identidade",
  "admin.settings.saveProfile": "SALVAR Perfil e Função",
  "admin.settings.season": "SEASON",
  "admin.settings.secondaryColor": "COR SECUNDÁRIA",
  "admin.settings.subtitle": "Personalize a sua experiência e a identidade visual do seu clube.",
  "admin.settings.teamBadge": "ESCUDO DA EQUIPE",
  "admin.settings.teamIdentity": "Identidade da Equipe",
  "admin.settings.teamName": "NOME DA EQUIPE",
  "admin.settings.terms": "Termos",
  "admin.settings.title": "Configurações do Sistema",
  "admin.settings.uploadImage": "Enviar Imagem",
  "admin.shield_error": "No se pudo subir ou procesar a imagen.",
  "admin.shield_saved": "Escudo salvo e otimizado com sucesso!",
  "admin.svg_shield_saved": "Escudo vetorial SVG salvo com sucesso!",
  "admin.tab.ajustes": "Configurações",
  "admin.tab.club": "Club",
  "admin.tab.ejercicios": "Exercícios",
  "admin.tab.equipos": "Times",
  "admin.tab.exportar": "Exportar",
  "admin.tab.general": "General",
  "admin.tab.suscripcion": "Assinatura",
  "admin.team_identity_error": "Error al atualizar identidad do time.",
  "admin.team_identity_updated": "Time identity updated successfully.",
  "admin.theme.dark": "Modo Oscuro",
  "admin.title": "Painel de Administração do Clube",
  "admin.update_check_error": "No se pudo comprobar actualizaciones.",
  "admin.update_connect_error": "Error al conectar com ou servidor.",
  "admin.xp.absent": "XP Ausente",
  "admin.xp.desc": "Configure os pontos de XP atribuídos por status de presença confirmado e os objetivos de temporada da equipe.",
  "admin.xp.excused": "XP Justificado",
  "admin.xp.goals": "Meta de Gols da Temporada",
  "admin.xp.late": "XP Atraso",
  "admin.xp.present": "XP Presente",
  "admin.xp.saveBtn": "Configurações de XP",
  "admin.xp.title": "Temporada e Tabela de XP Diferenciada",
  "admin.xp.veteran": "% Partidas Veterano",
  "admin.xp_error": "Error al salvar configurações de XP.",
  "admin.xp_saved": "Tabela de XP e objetivos de temporada salvos com sucesso.",
  "analisis.btnExportPdf": "Exportar Analysis PDF",
  "analisis.chart.axisCounterEff": "Eficacia Contras",
  "analisis.chart.axisDuels": "% Duelos",
  "analisis.chart.axisLossControl": "Controle de Perdas",
  "analisis.chart.axisRecoveries": "Recuperaciones",
  "analisis.chart.axisShots": "Tiros a Puerta",
  "analisis.chart.bars": "Comparativo Direto de Eventos",
  "analisis.chart.duels": "% Duelos Ganados",
  "analisis.chart.losses": "Perdas de Bola",
  "analisis.chart.radar": "Radar de Perfil Tático Médio",
  "analisis.chart.recoveries": "Recuperaciones",
  "analisis.chart.shotsOwn": "Tiros Propios",
  "analisis.chart.shotsOwnTitle": "Tiros a Puerta Propios",
  "analisis.chart.shotsRival": "Tiros Rival",
  "analisis.chart.trend": "Evolución e Tendencia de Rendimiento",
  "analisis.exportPdf": "Baixar PDF Analysis",
  "analisis.exportingPdf": "Generando PDF...",
  "analisis.kpi.counters": "Efectividad Contraataque",
  "analisis.kpi.countersSub": "Taxa de conversão de recuperações",
  "analisis.kpi.duels": "Duelos Ganados",
  "analisis.kpi.duelsSub": "Eficácia global em duelos",
  "analisis.kpi.recLossSubAvg": "Média Rec / Perdas",
  "analisis.kpi.recLossSubTot": "Total Rec / Perdas",
  "analisis.kpi.recoveries": "Recuperações / Perdas",
  "analisis.kpi.recoveriesSub": "Média Rec / Perdas",
  "analisis.kpi.recoveriesSubTotal": "Total Rec / Perdas",
  "analisis.kpi.shots": "Tiros a Puerta",
  "analisis.kpi.shotsSub": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubAvg": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubTot": "Total Propio vs Rival",
  "analisis.kpi.shotsSubTotal": "Total Propio vs Rival",
  "analisis.loadingData": "Cargando eventos de partidas...",
  "analisis.modal.all": "Todos",
  "analisis.modal.clear": "Limpiar",
  "analisis.modal.confirm": "ACEPTAR Y COMPARAR",
  "analisis.modal.noDate": "Sin fecha",
  "analisis.modal.pending": "Pendiente",
  "analisis.modal.selectedCount": "{count} partidas seleccionados",
  "analisis.modal.title": "Select Jogos to Compare",
  "analisis.modal.withData": "Com dados",
  "analisis.mode.averages": "Promedios",
  "analisis.mode.title": "Metrics:",
  "analisis.mode.totals": "Totales",
  "analisis.noMatchesSelected": "Selecciona al menos 1 partida para realizar ou análisis comparativo",
  "analisis.selectMatches": "Select Jogos",
  "analisis.shortcuts.allSeason": "Toda a Temporada",
  "analisis.shortcuts.last3": "Last 3",
  "analisis.shortcuts.last5": "Last 5",
  "analisis.shortcuts.title": "ATAJOS:",
  "analisis.subtitle": "Evolución táctica, tiros, duelos e recuperaciones a lo largo de a temporada",
  "analisis.table.cards": "Tarjetas (A / R)",
  "analisis.table.duels": "Duelos %",
  "analisis.table.fouls": "Faltas (F / C)",
  "analisis.table.match": "Partida / Adversário",
  "analisis.table.recLoss": "Rec / Perd",
  "analisis.table.result": "Resultado",
  "analisis.table.shots": "Tiros (P / R)",
  "analisis.table.title": "Detalhamento por Partida",
  "analisis.title": "Análise de Desempenho e Vídeo",
  "app.copyright": "2026 Mister11 · {slogan}",
  "app.slogan": "O banquillo en tu bolsillo",
  "attendance.banner.closeMatchSheet": "Fechar Súmula",
  "attendance.banner.completeSession": "📋 Concluir Sessão",
  "attendance.banner.unclosedEvents": "Você tem {sessions} sessão{sPlural} sem registrar e {matches} partida{mPlural} com súmula aberta.",
  "attendance.banner.unclosedSubtitle": "Complete e feche para oficializar as % de presença e os minutos dos jogadores.",
  "attendance.btn.exportPdf": "📄 Exportar PDF",
  "attendance.callup.activeWindow": "Janela de Avaliação Ativa",
  "attendance.callup.consider": "Avaliar",
  "attendance.callup.notRecommended": "Não recomendado",
  "attendance.callup.recommended": "Recomendado",
  "attendance.callup.subtitle": "Métricas de presença real sobre sessões agendadas para orientar sua próxima convocação.",
  "attendance.callup.thBreakdown": "Detalhamento (P / A / J / F / SR)",
  "attendance.callup.thGuidance": "Orientação",
  "attendance.callup.thPct": "% Janela",
  "attendance.callup.thPlayer": "Jogador",
  "attendance.callup.thStreak": "🔥 Sequência",
  "attendance.callup.title": "🎯 Assistente de Convocação por Presença",
  "attendance.callup.window.biweekly": "Quinzena",
  "attendance.callup.window.microcycle": "Microciclo",
  "attendance.callup.window.season": "Temporada",
  "attendance.callup.window.week": "Semana",
  "attendance.chart.filtersTitle": "Séries do Gráfico e Explicação (Clique para Mostrar/Ocultar)",
  "attendance.chart.guide.example": "Actualmente tu time promedia um {avg}% de asistencia en os {count} eventos disputados.",
  "attendance.chart.guide.step1": "1. Cada punto es um entreno ou partida: ordenados cronológicamente.",
  "attendance.chart.guide.step2": "2. A línea verde es tu asistencia: por encima do 70% vas bien.",
  "attendance.chart.guide.step3": "3. Si a roja sube mientras a verde baja: hay um problema de compromiso a corregir.",
  "attendance.chart.guide.step4": "4. Toca cualquier punto para ver ou detalle e abrir su registro.",
  "attendance.chart.guide.title": "Como interpretar este gráfico?",
  "attendance.chart.guideCoach": "Guia de Interpretação para a Comissão Técnica",
  "attendance.chart.guideStep1": "1. Pontos e Cronologia",
  "attendance.chart.guideStep2": "2. Linha Verde",
  "attendance.chart.guideStep3": "3. Cruzamento de Alerta",
  "attendance.chart.guideStep4": "4. Toque para Detalhes",
  "attendance.chart.legend.absent": "Ausentes",
  "attendance.chart.legend.absent.desc": "Faltas sem avisar. Debe tender a cero.",
  "attendance.chart.legend.attendance": "Presença Real (P+A)",
  "attendance.chart.legend.attendance.desc": "Jogadores who attended (present + late). The higher, the better.",
  "attendance.chart.legend.justified": "Justificados",
  "attendance.chart.legend.justified.desc": "Avisos justificados. No castiga ou % principal.",
  "attendance.chart.legend.late": "Tardes",
  "attendance.chart.legend.late.desc": "Llegadas tarde. Vigila si sube varias semanas seguidas.",
  "attendance.chart.legend.official": "Oficial (acta ou sessão cerrada)",
  "attendance.chart.legend.provisional": "Provisional (acta ou sessão abierta)",
  "attendance.chart.legend.threshold70": "Limite de alerta (70%): abaixo, risco de convocação.",
  "attendance.chart.noData": "Ainda não há sessões nem partidas registradas.",
  "attendance.chart.openRegister": "Abrir Registro de Presença",
  "attendance.chart.summaryStats": "Resumen do Evento Seleccionado",
  "attendance.chart.title": "Time Attendance Evolution",
  "attendance.markAllPresent": "Marcar Todos como Presentes",
  "attendance.register.closingSheet": "Fechando Súmula...",
  "attendance.register.customNew": "+ Nova Data de Presença Personalizada",
  "attendance.register.date": "Data",
  "attendance.register.excludeTitle": "Exclui esta sessão do cálculo de presença de todo o elenco",
  "attendance.register.expected": "⚽ Esperados: {attended} de {total}",
  "attendance.register.extraSession": "Sessão Extra",
  "attendance.register.futureSession": "🕐 Sessão futura",
  "attendance.register.markAllPresent": "Marcar Todos Presentes",
  "attendance.register.markSuspended": "Marcar Suspensa",
  "attendance.register.matchSheetClosed": "📋 Súmula Oficial Fechada",
  "attendance.register.matchSheetOpen": "⏳ Súmula Aberta",
  "attendance.register.officialNote": "✅ Oficial · confirmado pela comissão",
  "attendance.register.officialSaved": "✅ Registro oficial salvo",
  "attendance.register.pendingRegistration": "⏳ Pendente de registro",
  "attendance.register.prefillRsvp": "⚡ Preencher via RSVP",
  "attendance.register.prefillTooltip": "Preencher a partir das respostas do jogador sem sobrescrever edições manuais",
  "attendance.register.provisionalNote": "⏳ Provisório · conforme resposta do jogador (toque para confirmar)",
  "attendance.register.reopenSheet": "🔓 Reabrir Súmula",
  "attendance.register.rsvpLiveTitle": "📲 Respostas RSVP do Jogador e Planejamento (ao vivo)",
  "attendance.register.saveAndCloseSheet": "Salvar e Fechar Súmula",
  "attendance.register.saveAttendance": "Salvar Presença",
  "attendance.register.selectEvent": "Selecione Sessão de Treino ou Partida:",
  "attendance.register.sessionsAndMatches": "Sessões e Partidas",
  "attendance.register.suspendedActive": "Suspensa (Ativo)",
  "attendance.register.suspendedSession": "🌧️ Sessão Suspensa",
  "attendance.register.title": "Título",
  "attendance.register.updateNotice": "ℹ️ Você pode atualizar a chamada a qualquer momento; reflete na hora",
  "attendance.rsvp.going": "Confirmado",
  "attendance.rsvp.justified": "Justificado",
  "attendance.rsvp.late": "Chegará tarde",
  "attendance.rsvp.none": "Sem resposta",
  "attendance.rsvp.not_going": "Não irá",
  "attendance.saveBtn": "Salvar Presença",
  "attendance.saveError": "Erro ao salvar a presença. Tente novamente.",
  "attendance.saveSuccess": "Presença salva com sucesso.",
  "attendance.saving": "Salvando...",
  "attendance.status.absent": "Ausente",
  "attendance.status.injured": "Lesionado",
  "attendance.status.justified": "Justificado",
  "attendance.status.late": "Atrasado",
  "attendance.status.present": "Presente",
  "attendance.status.unmarked": "Não registrado",
  "attendance.summary.acceptable": "✓ Aceitável",
  "attendance.summary.noData": "⚪ Sem dados",
  "attendance.summary.optimal": "✓ Ótimo",
  "attendance.summary.risk": "⚠️ Risco",
  "attendance.summary.sortBy": "Sort by:",
  "attendance.summary.sortName": "Nome",
  "attendance.summary.sortNumber": "Número",
  "attendance.summary.sortPctAsc": "% Presença (Menor para Maior)",
  "attendance.summary.sortPctDesc": "% Presença (Maior para Menor)",
  "attendance.summary.thAbsent": "Ausente",
  "attendance.summary.thAttendance": "% Presença",
  "attendance.summary.thInjured": "Lesão",
  "attendance.summary.thJustified": "Justif.",
  "attendance.summary.thLate": "Atraso",
  "attendance.summary.thNoRecord": "SR",
  "attendance.summary.thPresent": "Presente",
  "attendance.summary.thStatus": "Status",
  "attendance.summary.threshold": "Limite de Alerta:",
  "attendance.summary.title": "👥 Resumo de Presença do Elenco ({count} jogadores)",
  "attendance.tab.callup": "🎯 Assistente de Convocação",
  "attendance.tab.register": "📋 Registro por Sessão",
  "attendance.tab.summary": "📊 Resumo do Elenco",
  "attendance.tab.trend": "📈 Evolução / Gráfico",
  "attendance.toast.allMarkedPresent": "Todos marcados como presentes (Oficial)",
  "attendance.toast.errorClosing": "Erro ao fechar a súmula oficial",
  "attendance.toast.errorReopening": "Erro ao reabrir a súmula",
  "attendance.toast.errorSaving": "Erro ao salvar a presença",
  "attendance.toast.noResponses": "Nenhum jogador respondeu ainda",
  "attendance.toast.savedSuccess": "Presença salva com sucesso",
  "attendance.toast.selectFirst": "Selecione primeiro uma sessão ou partida",
  "attendance.toast.sheetClosed": "Súmula oficial fechada e minutos calculados",
  "attendance.toast.sheetReopened": "Súmula reaberta para edição",
  "attendance.toast.suspendedSaved": "Sessão marcada como suspensa e salva",
  "auth.coachRole": "Soy Entrenador / Staff",
  "auth.email": "E-mail",
  "auth.forgotPass": "Esqueceu sua senha?",
  "auth.googleBtn": "Continuar com Google",
  "auth.hasAccount": "Já tem uma conta?",
  "auth.joinBtn": "Enviar Solicitação",
  "auth.joinTeam": "Entrar em um Time",
  "auth.loginBtn": "ENTRAR",
  "auth.loginLink": "Entrar",
  "auth.loginTitle": "Entrar no Mister11",
  "auth.logout": "Cerrar Sessão",
  "auth.noAccount": "Não tem uma conta?",
  "auth.parentRole": "Soy Padre / Tutor",
  "auth.password": "Senha",
  "auth.playerRole": "I am Jogador",
  "auth.registerLink": "Cadastre-se grátis",
  "auth.registerTitle": "Criar Conta",
  "auth.switched_coach": "Cambiado a Modo Entrenador",
  "auth.switched_player": "Switched to Jogador Portal",
  "auth.teamCode": "Código de Convite (6 dígitos)",
  "block.abp": "Bolas Paradas",
  "block.physical": "Physical",
  "block.tactical": "Tática",
  "block.technical": "Technical",
  "block.warmup": "Aquecimento",
  "board.actions.delete": "LIMPAR",
  "board.actions.hideRival": "👁 OCULTAR ADVERSÁRIO",
  "board.actions.showRival": "👁 MOSTRAR ADVERSÁRIO",
  "board.actions.title": "AÇÕES",
  "board.export.encodingProgress": "Codificando video MP4...",
  "board.export.encodingTitle": "Exportando Video MP4",
  "board.exportModal.btnCancel": "CANCEL",
  "board.exportModal.btnDownload": "DESCARGAR",
  "board.exportModal.btnExport": "EXPORT",
  "board.exportModal.btnReset": "Restablecer encuadre",
  "board.exportModal.btnShare": "SHARE",
  "board.exportModal.closeModal": "Fechar modal",
  "board.exportModal.completedDesc": "O archivo ha sido procesado e salvo correctamente.",
  "board.exportModal.completedTitle": "Exportar Completed!",
  "board.exportModal.exportPath": "Ruta / Destino",
  "board.exportModal.failed": "Error durante a exportación. Pulsa para reintentar.",
  "board.exportModal.format": "Exportar Format",
  "board.exportModal.framingTitle": "Enquadramento e Pré-visualização",
  "board.exportModal.landscape": "Horizontal (Modo paisagem)",
  "board.exportModal.loadingPreview": "Cargando encuadre de a animación...",
  "board.exportModal.metaDuration": "Duração estimada",
  "board.exportModal.metaSize": "Tamanho estimado",
  "board.exportModal.metaTitle": "Título do arquivo",
  "board.exportModal.oneFrame": "1 Fotograma",
  "board.exportModal.orientation": "Orientação",
  "board.exportModal.portrait": "Vertical (Modo retrato)",
  "board.exportModal.preparing": "Preparando quadros para renderização...",
  "board.exportModal.quality": "Qualidade / Resolução",
  "board.exportModal.shared": "¡Compartida!",
  "board.exportModal.speed": "Velocidade de Reprodução",
  "board.exportModal.subtitle": "Configura os parámetros de exportación e previsualiza ou encuadre",
  "board.exportModal.title": "Exportar Tactical Animation",
  "board.exportModal.zoomIn": "Acercar",
  "board.exportModal.zoomOut": "Alejar",
  "board.fields.blank": "Quadro em Branco",
  "board.fields.f7": "Futebol 7 (65x45m)",
  "board.fields.f8": "Futebol 8 (62x46m)",
  "board.fields.full": "Campo Inteiro",
  "board.fields.futsal": "Futsal (40x20m)",
  "board.fields.halfAttack": "½ Ataque",
  "board.fields.halfDefense": "½ Defesa",
  "board.fields.penaltyArea": "Grande Área",
  "board.fields.reduced": "Campo Reduzido",
  "board.fields.thirdAttack": "Terço Ofensivo",
  "board.fields.thirdDefense": "Terço Defensivo",
  "board.fields.thirdMid": "Terço Médio",
  "board.mat.aro": "Bambolê / Aro",
  "board.mat.balon": "Bola de Futebol",
  "board.mat.balon_movimiento": "Bola em Movimento",
  "board.mat.balon_negro": "Bola Preta",
  "board.mat.banderin": "Bandeirinha",
  "board.mat.cono": "Cone",
  "board.mat.cono_amarillo": "Cone Amarelo",
  "board.mat.cono_negro": "Cone Preto",
  "board.mat.cono_rojo": "Cone Vermelho",
  "board.mat.escalera": "Escada de Agilidade",
  "board.mat.flecha_ataque_h": "Seta de Ataque Horizontal",
  "board.mat.flecha_ataque_v": "Seta de Ataque Vertical",
  "board.mat.grupo_balones": "Grupo de Bolas",
  "board.mat.grupo_conos": "Grupo de 3 Cones",
  "board.mat.grupo_conos_arco": "Arco de 5 Cones",
  "board.mat.grupo_conos_linea": "Linha de 5 Cones",
  "board.mat.indicador_espacio": "Indicador de Espaço",
  "board.mat.jugador_camiseta": "Jersey Jogador",
  "board.mat.jugador_triangulo": "Triangle Jogador",
  "board.mat.linea_distancia": "Linha de Distância",
  "board.mat.mini_cono": "Mini Cone",
  "board.mat.pared_rebote": "Parede de Rebote",
  "board.mat.peto": "Colete de Treino",
  "board.mat.pica": "Estaca de Agilidade",
  "board.mat.platillo": "Prato / Tartaruga",
  "board.mat.porteria_grande": "Gol Oficial",
  "board.mat.porteria_lateral": "Gol Lateral",
  "board.mat.porteria_pequena": "Gol Pequeno",
  "board.mat.poste": "Boneco / Poste",
  "board.mat.valla": "Barreira de Salto",
  "board.mat.zona_circular": "Zona Circular",
  "board.mat.zona_grid": "Grade 3x3",
  "board.mat.zona_rectangular": "Zona Retangular",
  "board.mat.zona_rombo": "Zona Losango",
  "board.mat.zona_triangular": "Zona Triangular",
  "board.matCat.balon": "BOLAS",
  "board.matCat.coordinacion": "COORDENAÇÃO",
  "board.matCat.jugadores": "JOGADORES",
  "board.matCat.material": "MATERIAL",
  "board.matCat.medidas": "MEDIDAS",
  "board.matCat.porteria": "GOLS / BALIZAS",
  "board.matCat.señalizacion": "SINALIZAÇÃO",
  "board.matCat.zonas": "ZONAS",
  "board.panels.materials": "Material",
  "board.panels.teams": "Times",
  "board.panels.teamsAndFormations": "Equipos e Formaciones",
  "board.stroke.fine": "Fino",
  "board.stroke.medium": "Médio",
  "board.stroke.thick": "Grosso",
  "board.teams.apply": "APLICAR",
  "board.teams.local": "Titulares",
  "board.teams.rival": "Adversário",
  "board.teams.title": "EQUIPES",
  "board.teams.wildcard": "Curinga",
  "board.timeline.addFrame": "Adicionar quadro",
  "board.timeline.deleteFrame": "Excluir frame",
  "board.timeline.export": "Exportar",
  "board.timeline.exportAnimation": "Exportar animation",
  "board.timeline.firstFrame": "Primer fotograma",
  "board.timeline.frameLabel": "Quadro",
  "board.timeline.lastFrame": "Último quadro",
  "board.timeline.nextFrame": "Siguiente fotograma",
  "board.timeline.play": "Reproducir",
  "board.timeline.playAria": "Reproduzir animação",
  "board.timeline.prevFrame": "Fotograma anterior",
  "board.timeline.stop": "Detener",
  "board.timeline.stopAria": "Parar reprodução",
  "board.tool.straight_dashed_line": "Linha reta tracejada",
  "board.tool.zone_hexagon": "Zona hexagonal",
  "board.tool.zone_pentagon": "Zona pentagonal",
  "board.toolbar.clearCanvas": "Limpiar todo ou canvas",
  "board.toolbar.exportMp4": "EXPORTAR MP4",
  "board.toolbar.exportingMp4": "REC... EXPORTANDO MP4",
  "board.toolbar.fieldType": "Pitch type",
  "board.toolbar.fullscreen": "Tela Cheia",
  "board.toolbar.height": "Alto",
  "board.toolbar.new": "NEW",
  "board.toolbar.redo": "Rehacer",
  "board.toolbar.resetZoom": "Reiniciar Zoom",
  "board.toolbar.save": "SALVAR",
  "board.toolbar.sides": "Lados",
  "board.toolbar.strokeColor": "Cor do Traço",
  "board.toolbar.strokeWidth": "Espessura do Traço",
  "board.toolbar.swapSides": "Alternar lados dos times",
  "board.toolbar.undo": "Deshacer",
  "board.toolbar.width": "Ancho",
  "board.toolbar.zoomIn": "Acercar",
  "board.toolbar.zoomOut": "Alejar",
  "bottomnav.admin": "Admin",
  "bottomnav.ajustes": "Configurações",
  "bottomnav.equipo": "Time",
  "bottomnav.home": "Início",
  "bottomnav.ia": "AI",
  "bottomnav.more": "Mais",
  "bottomnav.moreModules": "Módulos e Gestão",
  "bottomnav.partidos": "Jogos",
  "bottomnav.pizarra": "Quadro",
  "bottomnav.planificacion": "Planejamento",
  "bottomnav.sesiones": "Sessões",
  "bottomnav.tests": "Testes",
  "btn.add": "ADICIONAR",
  "btn.back": "VOLTAR",
  "btn.cancel": "CANCEL",
  "btn.close": "FECHAR",
  "btn.confirm": "CONFIRMAR",
  "btn.delete": "EXCLUIR",
  "btn.deleteAccount": "Excluir Account & Data (GDPR)",
  "btn.edit": "EDITAR",
  "btn.export": "EXPORTAR PDF",
  "btn.filter": "FILTRAR",
  "btn.save": "SALVAR",
  "btn.search": "BUSCAR",
  "capture.criteria.downloadPdf": "Baixar Official PDF",
  "capture.criteria.search": "Buscar criterion...",
  "capture.criteria.title": "Manual de Critérios de Captura",
  "capture.hud.advanced": "Avanzado",
  "capture.hud.duel_lost": "Duelo Perdido",
  "capture.hud.duel_won": "Duelo Ganado",
  "capture.hud.foul": "Falta",
  "capture.hud.key_pass": "Pase Clave",
  "capture.hud.recovery": "Recuperação",
  "capture.hud.shot": "Tiro",
  "capture.hud.turnover": "Perda de Bola",
  "capture.hud.unattributed": "Sin atribuir",
  "capture.refine_btn": "Refinar atribuição",
  "capture.refine_empty": "Nada pendente ✅",
  "capture.refine_prompt_title": "Refinar atribuição individual agora? (opcional)",
  "capture.refine_skip": "Omitir",
  "capture.refine_subtitle": "Time totals are already computed. Assign only what you want to reflect on ratings, radars, and XP.",
  "capture.refine_title": "Refinar atribuição individual (opcional)",
  "capture.team.shot_own": "Tiro Propio",
  "capture.team.shot_rival": "Tiro Rival",
  "charts.guide.bars": "Comparativa cuantitativa de as 10 métricas clave de juego.",
  "charts.guide.momentum": "Evolución do dominio e control do partida en bloques de 15 minutos.",
  "charts.guide.radar": "Visualiza ou equilibrio táctico en 6 dimensiones entre ou time propio e ou rival.",
  "charts.guide.shots": "Distribución de remates e probabilidad esperada de gol (xG).",
  "charts.guide.zones": "Distribución territorial de as intervenciones do time en 9 cuadrantes.",
  "charts.insights.defensive_alert": "Aviso defensivo: O rival generó ocasiones claras com alta comodidad de remate.",
  "charts.insights.dominant_zone": "Zona dominante: Más do 40% de as intervenciones se concentraron en esta zona.",
  "charts.insights.finishing_deficit": "Eficacia rematadora: Volumen alto de ocasiones mas déficit en definición respecto al xG generado.",
  "charts.pass_insufficient_tooltip": "Se requieren al menos 5 pases registrados para generar a red táctica.",
  "charts.view.pass_network": "Rede de Passes",
  "charts.view.territorial_map": "Mapa Territorial",
  "chat.notif_from_player": "💬 Mensagem de {playerName}: \"{msgText}\"",
  "club.team_create_error": "Error al criar ou time do club.",
  "club.team_created": "Equipo do club creado correctamente.",
  "club.teams_assign_error": "Error al asignar times.",
  "club.teams_assigned": "Equipos asignados correctamente.",
  "cognitive.active_challenges_title": "Retos e Juegos Recomendados Activos ({count}):",
  "cognitive.assign_error": "Error al salvar as asignaciones",
  "cognitive.assigned_success": "✔ {count} recomendación(es) asignadas com éxito",
  "cognitive.btn_recommend_challenge": "Recomendar Reto",
  "cognitive.btn_verified": "✔ Verificado (+5 XP)",
  "cognitive.btn_verifying": "Verificando…",
  "cognitive.cat.alevin": "U-12",
  "cognitive.cat.benjamin": "U-10",
  "cognitive.cat.cadete": "U-16",
  "cognitive.cat.infantil": "U-14",
  "cognitive.cat.juvenil_adulto": "Juvenil / Adulto",
  "cognitive.category_label": "Categoria: {cat}",
  "cognitive.delete_recommendation": "Excluir recommendation",
  "cognitive.deselect_all": "Desmarcar todos",
  "cognitive.game.decision": "Decisão 1\"",
  "cognitive.game.freno": "Freno",
  "cognitive.game.memoria": "Memoria",
  "cognitive.game.ojo": "Olho Tático",
  "cognitive.game.respiracion": "Respiração 4-4",
  "cognitive.game.semaforo": "Traffic Light",
  "cognitive.level_by_game_title": "Nível por Jogo (Mérito Adaptativo)",
  "cognitive.metric_avg_accuracy": "Precisão média",
  "cognitive.metric_median_reaction": "Tempo mediano de reação",
  "cognitive.metric_sessions_week": "Sessões this week",
  "cognitive.metric_trend": "Tendencia",
  "cognitive.modal_assign_title": "⭐ Asignar Retos ou Juegos",
  "cognitive.modal_cog_games": "🧠 Juegos Cognitivos ({count}/{total}):",
  "cognitive.modal_confirm_assign": "Confirmar {count} assignment(s)",
  "cognitive.modal_entire_team": "Toda a plantilla do time",
  "cognitive.modal_home_retos": "⚽ Desafios em Casa ({count}/{total}):",
  "cognitive.modal_only_player": "Solo {name}",
  "cognitive.modal_recipient_label": "Destinatario:",
  "cognitive.modal_select_min": "Selecione pelo menos um desafio ou jogo",
  "cognitive.recommendation_deleted": "Recomendação excluída",
  "cognitive.select_all": "Marcar todos",
  "cognitive.supervision_title": "Supervisión Cognitiva e Retos en Casa",
  "cognitive.target_player": "Individual",
  "cognitive.target_team": "Todo el time",
  "cognitive.trend_improving": "↑ Em evolução",
  "cognitive.trend_stable": "= Estable",
  "cognitive.verified_xp": "✔ Retos verificados: +5 XP asignados a {name}",
  "cognitive.verify_error": "Erro ao registrar verificação",
  "cognitive.week_sessions": "Semana actual · {count} sessões registradas",
  "common.absent": "Ausente",
  "common.all": "TODOS",
  "common.away": "Visitante",
  "common.back": "Voltar",
  "common.cancel": "Cancelar",
  "common.close": "Fechar",
  "common.closeMenu": "Fechar menu",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.email": "E-mail",
  "common.errorGeneral": "Ocorreu um erro inesperado",
  "common.excused": "Justificado",
  "common.friendly": "Amistoso",
  "common.genericError": "Erro na operação",
  "common.home": "Início",
  "common.injured": "Lesionado",
  "common.loading": "Carregando...",
  "common.matchTag": "Partida",
  "common.myTeam": "Meu Time",
  "common.no": "Não",
  "common.noData": "Sem dados",
  "common.official": "Oficial",
  "common.optimal": "Ótimo",
  "common.originalBadgeEn": "EN original",
  "common.originalBadgeEs": "Original ES",
  "common.originalLanguage": "Idioma original",
  "common.originalLanguageEn": "Idioma original: Inglês",
  "common.originalLanguageEs": "Idioma original: Espanhol",
  "common.player": "Jogador",
  "common.present": "Presente",
  "common.risk": "Risco",
  "common.rival": "Adversário",
  "common.save": "Salvar",
  "common.savedSuccess": "Salvo com sucesso",
  "common.saving": "Salvando...",
  "common.sessionTag": "Sessão",
  "common.starter": "Titular",
  "common.substitute": "Reserva",
  "common.success": "Operação concluída com sucesso",
  "common.training": "Treino",
  "common.yes": "Sim",
  "consent.authAvatar": "Fotografía ou avatar identificativo do jogador en as alineaciones e pizarra",
  "consent.authBiometric": "Ficha antropométrica (altura e peso corporal para ou seguimiento físico e IMC)",
  "consent.authDob": "Fecha de nacimiento (Requerido para ou cálculo automático de edad e categoría)",
  "consent.authExercises": "Asignación de planes de treinamento de recuperación e individuales",
  "consent.authInjuries": "Historial clínico de lesiones sufridas (dados médicos de salud - Art. 9 RGPD)",
  "consent.authName": "Nombre e sobrenome (Requerido para a ficha do jogador)",
  "consent.authPhysicalTests": "Resultados de pruebas e tests físicos de aptitud e rendimiento",
  "consent.authPosition": "Posición deportiva e número de dorsal asignado",
  "consent.authPsychosocial": "Cuestionarios psicosociales e tests diarios de bienestar (fatiga, sueñou, estrés, humor)",
  "consent.authSessions": "Registros de asistencia e participación en partidas, alineaciones e informes técnicos",
  "consent.clearSig": "Limpar painel de assinatura",
  "consent.coachNameLabel": "Primer Entrenador / Responsable",
  "consent.coachNamePlaceholder": "Nome do Treinador",
  "consent.detailsTitle": "Detalhes do Consentimento",
  "consent.errBasicAuth": "Es obligatorio autorizar ou tratamiento do nome e data de nacimiento para poder registrar al jogador en a aplicación.",
  "consent.errParentDni": "O DNI/NIE/Pasaporte do tutor es obligatorio.",
  "consent.errParentName": "O nome do padre/madre/tutor es obligatorio.",
  "consent.errPlayerDob": "Jogador date of birth is required.",
  "consent.errPlayerName": "Jogador name (underage) is required.",
  "consent.errSig": "Por favor, dibuja tu firma digital en ou recuadro antes de continuar.",
  "consent.footerLegal": "Mister11 no almacena tus dados de contacto, a firma ni ou archivo PDF en sus bases de dados. O documento PDF se procesa de forma temporal e instantánea en a memoria de tu propio navegador móvil/ordenador. A custodia legal do documento PDF firmado recae enteramente en os padres/tutores e en ou entrenador a cargo de a gestión do time.",
  "consent.heading": "Consentimiento Parental Digital",
  "consent.instructions": "Cumplimente os dados requeridos. Os campos marcados com (*) son obligatorios.",
  "consent.notifyWhatsapp": "Notificar o treinador pelo WhatsApp",
  "consent.parentDniLabel": "DNI / NIE / Pasaporte *",
  "consent.parentDniPlaceholder": "Ej. 12345678Z",
  "consent.parentNameLabel": "Nome do Responsável *",
  "consent.parentNamePlaceholder": "Nombre y Apellidos",
  "consent.parentPhoneLabel": "Telefone de Contato",
  "consent.parentPhonePlaceholder": "Ej. +34 600 000 000",
  "consent.playerDobLabel": "Data de Nascimento *",
  "consent.playerNameLabel": "Jogador Name *",
  "consent.playerNamePlaceholder": "Nombre y Apellidos",
  "consent.privacyDesc": "Este documento ha sido generado de manera local. Mister11 no almacena copias de tu firma ni do consentimiento en sus servidores. Envía ou PDF descargado al entrenador por WhatsApp para que lo conserve de forma segura.",
  "consent.privacyTitle": "AVISO DE PRIVACIDADE",
  "consent.redownloadPdf": "Baixar PDF Again",
  "consent.relationFather": "Padre",
  "consent.relationGuardian": "Tutor Legal / Representante",
  "consent.relationLabel": "Parentesco *",
  "consent.relationMother": "Madre",
  "consent.seasonLabel": "Temporada",
  "consent.sec1": "1. Datos do Padre, Madre ou Tutor",
  "consent.sec2": "2. Underage Jogador Details",
  "consent.sec3": "3. Time and Coach Details",
  "consent.sec4": "4. Autorizações de Dados Pessoais",
  "consent.sec4Desc": "Seleccione qué dados autoriza que sean procesados en Mister11 por ou cuerpo técnico:",
  "consent.sec5": "5. Declaração de Consentimento Expresso",
  "consent.sec5Text": "Por a presente, actuando en calidad de padre, madre ou tutor legal do menor arriba indicado, declaro que he sido informado de forma transparente sobre a finalidad e ou tratamiento de os dados deportivos e de bienestar do jogador en a plataforma Mister11. Otorgo mi consentimiento expreso para ou tratamiento de as casillas marcadas anteriormente.",
  "consent.sec6": "6. Assinatura Digital do Responsável",
  "consent.sigLabel": "Dibuja tu Firma com ou Dedo ou Ratón *",
  "consent.subTitle": "Autorización informada para a gestión deportiva do jogador menor de edad.",
  "consent.submitBtn": "Firmar e Generar Documento PDF",
  "consent.submittingBtn": "Generando PDF firmado...",
  "consent.successDesc": "O documento de consentimiento parental para ou jogador {name} se ha generado e descargado en tu dispositivo correctamente.",
  "consent.successTitle": "¡Firmado com Éxito!",
  "consent.teamNameLabel": "Time / Club",
  "consent.teamNamePlaceholder": "Time Name",
  "consent.whatsappMsg": "Hola entrenador, já he rellenado e firmado digitalmente ou consentimiento parental para {name}. He descargado ou PDF firmado en mi dispositivo. Te lo comparto a continuación.",
  "convocation.allRecipientsSelected": "Todos seleccionados",
  "convocation.cleanSelection": "Limpar seleção",
  "convocation.coachLabel": "ENTRENADOR / COACH",
  "convocation.competition": "Competição",
  "convocation.counter": "{count}/18 seleccionados",
  "convocation.defaultMessage": "Convocatoria para ou partida vs {opponent}. Revisad os detalles.",
  "convocation.download": "Baixar PNG",
  "convocation.downloading": "Descargando...",
  "convocation.generate": "Generar convocatoria PNG",
  "convocation.generatedWith": "Generado com Mister11",
  "convocation.generating": "Generando PNG...",
  "convocation.limitReached": "Límite alcanzado: máximo 18 jogadores convocados",
  "convocation.matchInfo.convocationTime": "Hora convocatoria (-1h)",
  "convocation.matchInfo.date": "Fecha",
  "convocation.matchInfo.location": "Lugar",
  "convocation.matchInfo.matchTime": "Jogo time",
  "convocation.matchInfo.rival": "Rival",
  "convocation.message": "Mensagem do comunicado",
  "convocation.missingPlayersWarning": "Se recomiendan 18 jogadores para a convocatoria completa.",
  "convocation.noMatchSelected": "No hay partida próximo programado.",
  "convocation.noPlayersSelected": "No has seleccionado ningún jogador.",
  "convocation.positions.def": "DEFENSAS",
  "convocation.positions.fwd": "DELANTEROS",
  "convocation.positions.gk": "PORTEROS",
  "convocation.positions.mid": "MEDIOCAMPISTAS",
  "convocation.positionsEn.def": "DEFENDERS",
  "convocation.positionsEn.fwd": "FORWARDS",
  "convocation.positionsEn.gk": "GOALKEEPERS",
  "convocation.positionsEn.mid": "MIDFIELDERS",
  "convocation.previewTitle": "Pré-visualização da Convocação",
  "convocation.quickAccess": "Convocatoria do próximo partida",
  "convocation.regenerate": "Regenerar / Editar",
  "convocation.round": "Jornada",
  "convocation.selectPlayers": "Selecciona os convocados",
  "convocation.send": "Enviar",
  "convocation.sendError": "Error al enviar a convocatoria.",
  "convocation.sendModalTitle": "Send Convocation to Jogadores",
  "convocation.sendSuccess": "Convocatoria enviada a os jogadores correctamente.",
  "convocation.sendToPlayers": "Enviar a jogadores",
  "convocation.sending": "Enviando...",
  "convocation.tab": "Convocatoria",
  "convocation.title": "Convocatória de Partida",
  "csv.browseFile": "Seleccionar Archivo",
  "csv.confirmImport": "Confirmar and Importar Jogadores",
  "csv.continueToPreview": "Continuar a Vista Previa",
  "csv.downloadTemplate": "Baixar CSV Template",
  "csv.dropzoneDesc": "Arquivos compatíveis: .csv, .xlsx, .xls (máx. 5MB)",
  "csv.dropzoneTitle": "Arrastra tu archivo aquí ou haz clic para seleccionarlo",
  "csv.errorDuplicateNumberFile": "Dorsal duplicado dentro do archivo.",
  "csv.errorDuplicateNumberTeam": "O dorsal já está ocupado en ou time.",
  "csv.errorEmptyFile": "O archivo seleccionado está vacíou.",
  "csv.errorInvalidNumber": "O dorsal debe ser um número entero entre 1 e 99.",
  "csv.errorInvalidPosition": "Posición no válida. Usa POR, DEF, MC, DEL ou equivalente.",
  "csv.errorMissingName": "Jogador name is required.",
  "csv.errorParsing": "No se pudo leer ou archivo. Comprueba ou formato CSV ou Excel.",
  "csv.errorPlanLimitExceeded": "Has alcanzado ou límite de jogadores permitido por tu plan.",
  "csv.errorUnsupportedFormat": "Formato no soportado. Usa archivos .csv ou .xlsx.",
  "csv.fieldBirthDate": "Data de Nascimento",
  "csv.fieldDorsal": "Número da Camisa",
  "csv.fieldEmail": "E-mail",
  "csv.fieldOptional": "Opcional",
  "csv.fieldPlayerName": "Jogador Name",
  "csv.fieldPosition": "Posição Principal",
  "csv.fieldRequired": "Requerido",
  "csv.importErrorToast": "Ocurrió um erro al importar os jogadores.",
  "csv.importSuccessToast": "Se han importado {count} jogadores com éxito.",
  "csv.mappingIntro": "Asigna as columnas de tu archivo a os campos de Mister11:",
  "csv.modalTitle": "Importar Jogadores via CSV / Excel",
  "csv.selectColumn": "Seleccionar columna...",
  "csv.status": "Estado",
  "csv.stepMapping": "Mapeo",
  "csv.stepPreview": "Vista Previa",
  "csv.stepUpload": "Subir",
  "csv.summaryErrors": "Filas com errores a corregir:",
  "csv.summaryReady": "Jogadores ready for import:",
  "csv.tagValid": "Valid",
  "csv.templateSubtitle": "Baixar our official CSV template with predefined headers.",
  "csv.templateTitle": "¿No tienes uma plantilla?",
  "dashboard.activity": "Aqui está a atividade da sua equipe ({club}) para esta semana.",
  "dashboard.devAccess": "Acesso de Desenvolvedor - Mister11 PRO",
  "dashboard.devDesc": "Sua conta tem acesso permanente vitalício com todos os limites removidos.",
  "dashboard.devUnlimited": "✔ DESENVOLVEDOR ILIMITADO",
  "dashboard.estimatedWorkload": "Carga de Trabalho Estimada",
  "dashboard.joinAsStaff": "Junte-se a uma equipe como Staff",
  "dashboard.noUpcomingSessions": "Não há sessões próximas.",
  "dashboard.period.macro": "Este macrociclo",
  "dashboard.period.meso": "Este mesociclo",
  "dashboard.period.micro": "Este microciclo",
  "dashboard.period.session": "Esta sessão",
  "dashboard.period.week": "Esta semana",
  "dashboard.quickAccess": "Acesso Rápido",
  "dashboard.saveDashboard": "SALVAR PAINEL",
  "dashboard.stats.matches": "Jogos",
  "dashboard.stats.noRival": "Sem adversário",
  "dashboard.stats.players": "Jogadores",
  "dashboard.stats.rival": "Próximo Adversário",
  "dashboard.stats.sessions": "Sessões",
  "dashboard.teamWorkloadIndex": "Índice de Carga de Trabalho",
  "dashboard.today": "Hoje",
  "dashboard.upcomingSessions": "Próximas Sessões",
  "dashboard.upgrade.activatePro": "Activar Modo PRO",
  "dashboard.upgrade.activateProTrial": "Activar Prueba PRO",
  "dashboard.upgrade.freePlanDesc": "Límites ativos: 1 time, 23 jogadores, 10 sessões e 5 generaciones de IA al mes.",
  "dashboard.upgrade.freePlanTitle": "⭐ Mister11 Plan Gratuito (Limitado)",
  "dashboard.upgrade.planActiveDesc": "Tienes acceso completo a todas as funciones. Gracias por ser parte de Mister11 PRO.",
  "dashboard.upgrade.planActiveTitle": "👑 Mister11 {plan} · Plan Activo",
  "dashboard.upgrade.renewAccess": "🔓 RENOVAR ACESSO",
  "dashboard.upgrade.resetTrial": "Reiniciar",
  "dashboard.upgrade.subscribe": "⚡ ASSINAR",
  "dashboard.upgrade.trialActiveDesc": "Tienes acceso total a todas as funciones premium. Te quedan {days} días ({hours}h) de prueba.",
  "dashboard.upgrade.trialActiveTitle": "👑 Mister11 {plan} · Prueba Gratuita Activa",
  "dashboard.upgrade.trialExpiredDesc": "🔒 Tu prueba gratuita ha finalizado. Suscríbete para recuperar ou acceso PRO.",
  "dashboard.upgrade.trialExpiringDesc": "Solo quedan {hours} de prueba. Suscríbete para no perder ou acceso.",
  "dashboard.upgrade.trialExpiringTitle": "⚠️ Seu período de testes expira em breve!",
  "dashboard.upgrade.tryFree": "Testar Grátis",
  "dashboard.upgrade.viewPlans": "Ver Planos PRO",
  "dashboard.upgrade.viewPlansPro": "👑 VER PLANES PRO",
  "dashboard.viewAll": "Ver todas",
  "dashboard.weeklyReport.desc": "Resumen de treinos e partidas de a semana ({sessions} sessões, {matches} partidas).",
  "dashboard.weeklyReport.download": "Baixar PDF",
  "dashboard.weeklyReport.ready": "Seu Relatório Semanal está pronto!",
  "dashboard.welcome": "Olá, {name}",
  "dashboard.workload.week": "Sem",
  "day.Dom": "Dom",
  "day.Jue": "Qui",
  "day.Lun": "Seg",
  "day.Mar": "Ter",
  "day.Mié": "Qua",
  "day.Sáb": "Sat",
  "day.Vie": "Sex",
  "download.cache_hint": "Salvo em cache. Se não abrir, procure \"{filename}\" em Arquivos",
  "download.csv_success": "✅ Plantilla exportada exitosamente.",
  "download.generic_error": "Erro ao exportar escalação",
  "download.image_success": "✅ Imagen exportada exitosamente.",
  "download.json_success": "✅ Archivo exportado exitosamente.",
  "download.lineup_downloading": "⬇️ Baixando escalação: {filename}",
  "download.lineup_saved": "✅ Alineación salva en {path}",
  "download.lineup_share_dialog": "Salvar or share lineup...",
  "download.lineup_share_title": "Mister11 — Escalação {team}",
  "download.pdf_error": "Error al salvar ou PDF",
  "download.pdf_ready": "✅ PDF listo: \"{filename}\"",
  "download.save_error_share_fallback": "⚠️ No se pudo salvar automáticamente; usa Compartir.",
  "download.saved_in": "✅ Salvo em: {path}",
  "download.video_success": "✅ Animação exportada com sucesso.",
  "equipo.loadingSquad": "Cargando plantilla...",
  "equipo.publishAnnouncement": "Publicar Comunicado",
  "equipo.tab.attendance": "Controle de Presença",
  "equipo.tab.squad": "Elenco",
  "equipo.tab.staff": "Comissão Técnica",
  "equipo.title": "Gestão da Equipe",
  "error.retry_section": "Reintentar",
  "error.section_code": "Code: {code}",
  "error.section_desc": "Ha ocurrido uma anomalía aislada al renderizar esta sección. O resto do partida continúa operativo.",
  "error.section_unavailable": "Seção temporariamente indisponível",
  "errors.codeAlreadyUsed": "Este código já foi utilizado.",
  "errors.codeExpired": "Este convite expirou.",
  "errors.codeInvalid": "Código inválido. Deve ter 6 caracteres.",
  "errors.codeNotFound": "Time not found. Verify the code or contact the coach.",
  "exerciseCatalog.categories.cooldown": "Volta à calma",
  "exerciseCatalog.categories.main": "Parte Principal",
  "exerciseCatalog.categories.warmup": "Aquecimento",
  "exerciseCatalog.clinicalFallbackNotice": "Fonte oficial em verificação",
  "exerciseCatalog.phases.fase1": "Fase 1: Corrida e Aquecimento Dinâmico",
  "exerciseCatalog.phases.fase2": "Fase 2: Força, Pliometria e Equilíbrio",
  "exerciseCatalog.phases.fase3": "Fase 3: Corrida em Alta Velocidade e Mudanças de Direção",
  "exerciseCatalog.sourceLabel": "Fonte",
  "exports.gk.claims": "Saídas / Rebatidas",
  "exports.gk.cleanSheets": "Jogos sem Sofrer Gols",
  "exports.gk.conceded": "Gols Sofridos",
  "exports.gk.errors": "Erros",
  "exports.gk.goalkeeper": "Goleiro",
  "exports.gk.penaltySaves": "Pênaltis Defendidos",
  "exports.gk.rating": "Nota Goleiro",
  "exports.gk.savePct": "% Eficácia",
  "exports.gk.saves": "Defesas",
  "exports.gk.title": "DESEMPENHO DO GOLEIRO",
  "exports.report.match_info": "Ficha do Jogo",
  "exports.report.page": "Página",
  "exports.report.sec10_players": "10. Desempenho Individual e do Elenco",
  "exports.report.sec11_swot": "11. Análise SWOT Tática e Recomendações",
  "exports.report.sec1_lineup": "1. Escalação Tática com Fotografias",
  "exports.report.sec2_timeline": "2. Placar e Linha do Tempo de Eventos",
  "exports.report.sec3_momentum": "3. Momentum e Posse por Blocos de 15'",
  "exports.report.sec4_bars": "4. Barras Comparativas (10 Métricas)",
  "exports.report.sec5_radar": "5. Radar Comparativo (Próprio vs Rival)",
  "exports.report.sec6_top5": "6. Top 5 Métricas Diferenciais",
  "exports.report.sec7_shots": "7. Mapas de Finalizações e Modelo xG-Lite",
  "exports.report.sec8_tactics": "8. Campo e Tática (Corredores, Bolas Paradas e Território)",
  "exports.report.sec9_gk": "9. Exigência e Desempenho dos Goleiros",
  "exports.report.sec_photos": "Fotos e Registros da Partida",
  "exports.report.tactical_analysis": "Análise Tática",
  "exports.report.title": "RELATÓRIO OFICIAL PÓS-JOGO",
  "exports.test.attendance": "Presença",
  "exports.test.mental": "Teste Mental / Psicossocial",
  "exports.test.physical": "Teste Físico",
  "exports.test.radar_title": "Perfil Integral de Desempenho",
  "exports.test.recommendation_title": "Recomendações Individuais",
  "exports.test.table_interp": "Interpretação",
  "exports.test.table_score": "Pontuação",
  "exports.test.table_test": "Teste",
  "exports.test.tactical": "Teste Tático",
  "exports.test.technical": "Teste Técnico",
  "exports.test.title": "RELATÓRIO DE AVALIAÇÃO E TESTES",
  "form.teamName": "Time Name",
  "games.assignment.todayPrompt": "O cuerpo técnico te ha asignado um reto especial",
  "games.badge.recommended": "Recommended by your coach",
  "games.best.accuracy": "Accuracy: {val}%",
  "games.best.hits": "Aciertos: {val}/5",
  "games.best.maxCones": "Max: {val} cones",
  "games.best.record": "Record: {val} ms",
  "games.btn.backToCatalog": "Voltar to Catalog",
  "games.btn.play": "Jugar",
  "games.btn.practiceFirst": "Try in Practice Mode",
  "games.btn.startOfficial": "Start Sessão",
  "games.btn.startReto": "Entrenar",
  "games.disclaimer": "Support cognitive training, not therapy; follow specialist advice for ADHD.",
  "games.finish.healthyClosing": "¡Gran trabajo mental! Descansa a vista e ou cuerpo.",
  "games.finish.subtitle": "Has concluído a sessão com dedicación.",
  "games.finish.title": "Outstanding effort!",
  "games.g1.falseStart": "🚫 False start.",
  "games.g1.skill": "Reaction Speed",
  "games.g1.statBest": "Mejor marca",
  "games.g1.statFalses": "Salidas falso",
  "games.g1.statMedian": "Médiana",
  "games.g1.step1": "Wait on red.",
  "games.g1.step2": "Toca a pantalla al ponerse VERDE.",
  "games.g1.step3": "Tapping earlier = false start.",
  "games.g1.tapAreaPrompt": "Tap here when it turns GREEN",
  "games.g1.tapNow": "TAP NOW!",
  "games.g1.title": "Pro Traffic Light",
  "games.g1.tooSlow": "Too slow! Miss.",
  "games.g1.waitGreen": "Wait for green…",
  "games.g1.what": "Reaccionar en milisegundos: salir al balón antes que ou rival.",
  "games.g1.why": "Llegar 0,2 s antes a um balón dividido cambia a jugada. A reacción se entrena e se transfiere a salidas e interceptaciones.",
  "games.g2.crMsg": "🛑 Perfect brake!",
  "games.g2.faMsg": "🚫 It was red: you had to brake.",
  "games.g2.missMsg": "⏱️ Se te escapó ou verde.",
  "games.g2.prepare": "Watch the cone…",
  "games.g2.skill": "Autocontrol e decisión",
  "games.g2.statAcc": "Accuracy",
  "games.g2.statFa": "Frenadas fallidas",
  "games.g2.statRt": "Tiempo medio",
  "games.g2.step1": "Aparece um cono en uma de as casillas.",
  "games.g2.step2": "GREEN → tap it quickly.",
  "games.g2.step3": "ROJO → NO lo toques, frena tu dedo.",
  "games.g2.title": "Freno Impulsivo",
  "games.g2.what": "Frenar ou impulso: decidir antes de actuar.",
  "games.g2.why": "A mayoría de errores vienen de actuar deprisa. O \"freno\" mejora ou regate, evita faltas e ajuda a jogadores com TDAH.",
  "games.g3.hitMsg": "✅ Open teammate found!",
  "games.g3.markedMsg": "❌ Ese estaba marcado. Mira ou despejado.",
  "games.g3.practiceGuide": "O compañero libre brilla en oro. ¡Tócalo!",
  "games.g3.rivalMsg": "😉 Ese es um rival. Busca al compañero.",
  "games.g3.scanPrompt": "Busca com a mirada…",
  "games.g3.skill": "Escaneo visual e percepción",
  "games.g3.statHits": "Aciertos",
  "games.g3.statRounds": "Rondas",
  "games.g3.statTime": "Tiempo medio",
  "games.g3.step1": "🟢 teammates · 🔴 opponents.",
  "games.g3.step2": "Toca al compañero com MÁS espacio libre.",
  "games.g3.step3": "5 seconds per round.",
  "games.g3.timeOut": "⏱️ Tiempo. O libre era ou mais despejado.",
  "games.g3.title": "Tactical Eye",
  "games.g3.what": "Ver ou juego: encontrar al compañero libre antes de recibir.",
  "games.g3.why": "Os profesionales escanean 6-8 veces cada 10 s. Ver al libre antes de recibir convierte uma buena decisión en um buen pase.",
  "games.g4.correctMsg": "✅ Perfect sequence!",
  "games.g4.missMsg": "❌ Fechar. Keep trying.",
  "games.g4.repeat": "¡Repite a secuencia!",
  "games.g4.skill": "Working Memory",
  "games.g4.statMax": "Max sequence",
  "games.g4.statOk": "Rondas acertadas",
  "games.g4.statRange": "Rango",
  "games.g4.step1": "Observa ou orden en que se iluminan os conos.",
  "games.g4.step2": "Repite a secuencia tocando os mismos conos.",
  "games.g4.step3": "Cada ronda a secuencia es mais larga.",
  "games.g4.title": "Cone Memory",
  "games.g4.watch": "Watch closely…",
  "games.g4.what": "Recordar informação bajo presión.",
  "games.g4.why": "Recordar consignas e movimientos mejora a atención e a comprensión táctica: a \"pizarra mental\" do jogador.",
  "games.g5.cycleHeader": "Cycle {current} of {total}",
  "games.g5.exhale": "Exhala",
  "games.g5.exhaleTip": "Suelta ou aire suavemente por a boca",
  "games.g5.inhale": "Inhala",
  "games.g5.inhaleTip": "Inhala despacio por a nariz llenando ou abdomen",
  "games.g5.skill": "Calma e autocontrol",
  "games.g5.statBenefit": "Beneficio",
  "games.g5.statCycles": "Ciclos",
  "games.g5.statTempo": "Tempo",
  "games.g5.step1": "O círculo crece → inhala suavemente por a nariz (4 s).",
  "games.g5.step2": "O círculo encoge → exhala despacio por a boca (4 s).",
  "games.g5.step3": "6 ciclos completos, sem prisas ni puntuación.",
  "games.g5.title": "4-4 Breathing",
  "games.g5.what": "Calmar os nervios antes de jugar.",
  "games.g5.why": "A respiración cuadrada 4-4 activa ou sistema parasimpático: baja pulso e ansiedad en ~1 min. A usan deportistas de élite; es simple e se hace en cualquier sitio. Por eso a elegimos.",
  "games.g5.zenBadge": "6 calm cycles",
  "games.g6.clueGoal": "Goal:",
  "games.g6.clueMate": "Teammate:",
  "games.g6.clueSpace": "Espacio libre:",
  "games.g6.optDribble": "DRIBBLE",
  "games.g6.optPass": "PASS",
  "games.g6.optShoot": "SHOT",
  "games.g6.prompt": "Decide fast!",
  "games.g6.skill": "Tactical Reading",
  "games.g6.statAcc": "Aciertos",
  "games.g6.statPct": "Accuracy",
  "games.g6.statTime": "Tiempo medio",
  "games.g6.step1": "Lee as 3 pistas en pantalla.",
  "games.g6.step2": "Goal OPEN → SHOT.",
  "games.g6.step3": "Otherwise, teammate OPEN → PASS. Else → DRIBBLE (4 s limit).",
  "games.g6.timeOutMsg": "⏱️ Tiempo. A mejor opción era {option}.",
  "games.g6.title": "1-Second Decision",
  "games.g6.what": "Elegir a mejor acción en um vistazo: pase, tiro ou conducción.",
  "games.g6.why": "O fútbol se juega com a cabeza: decidir rápido e bien marca a diferencia entre um jogador bueno e uno excelente.",
  "games.honesty.pact": "Pacto de honestidad: anota tus repeticiones reales. ¡O esfuerzo es tuyo!",
  "games.intro.howTitle": "How to Play",
  "games.intro.whatTitle": "What We Train",
  "games.intro.whyTitle": "Por qué te ajuda en ou campo",
  "games.legend_ceiling": "👑 ¡Alcanzaste ou techo de Leyenda! ¡Eres um crack!",
  "games.level_up": "🎉 You leveled up to {level}! {badge} (+10 XP)",
  "games.limits.available": "Disponible",
  "games.limits.cognitiveLbl": "Juegos Cognitivos",
  "games.limits.cognitiveLockedDesc": "Has alcanzado ou límite saludable de 15 minutos de juegos cognitivos. ¡A descansar a mente para consolidar lo aprendido!",
  "games.limits.cognitiveLockedTitle": "🧠 Mind trained for today!",
  "games.limits.completed": "Completado",
  "games.limits.completedToday": "Completed for today",
  "games.limits.lockedDesc": "Has alcanzado ou límite saludable de treinamento diario. Vuelve mañana para seguir mejorando.",
  "games.limits.lockedTitle": "Well done for today!",
  "games.limits.minutesLbl": "Tiempo jugado",
  "games.limits.remainingMin": "Te quedan {count} min hoy",
  "games.limits.remainingTime": "Te quedan {time} hoy",
  "games.limits.retosLbl": "Home Challenges",
  "games.limits.retosLockedDesc": "Has alcanzado tus 20 minutos de retos en casa por hoy. ¡Gran esfuerzo físico, recupérate para ou próximo entreno!",
  "games.limits.retosLockedTitle": "⚽ ¡Cuerpo e técnica trabajados!",
  "games.limits.sessionsLbl": "Sessões today",
  "games.limits.title": "Healthy Training",
  "games.ranking.empty": "Comienza tus treinos para inaugurar ou podio de a semana.",
  "games.ranking.resetInfo": "Reset cada lunes",
  "games.ranking.subtitle": "Um espacio de superación sana onde premiamos a constancia e ou progreso personal, no a rivalidad.",
  "games.ranking.tabImproved": "Most Improved",
  "games.ranking.tabPoints": "Puntos Semanales",
  "games.ranking.title": "Ranking Semanal Saludable",
  "games.retos.addRep": "+1 Repetition",
  "games.retos.attemptsExhausted": "Límite de 2 intentos por hoy alcanzado. ¡Descansa e vuelve mañana!",
  "games.retos.attemptsToday": "intentos hoy",
  "games.retos.btnStart": "Iniciar Reto",
  "games.retos.btnSuperado": "Completado hoy",
  "games.retos.completedBadge": "Superado hoy",
  "games.retos.completedResult": "Completado",
  "games.retos.crp.metric": "Mejor racha",
  "games.retos.crp.skill": "Coordenação",
  "games.retos.crp.title": "Cabeza-Rodilla-Pie",
  "games.retos.crp.what": "Head-knee-foot control sequence.",
  "games.retos.cuerda.metric": "Saltos totales",
  "games.retos.cuerda.skill": "Coordinación e resistencia",
  "games.retos.cuerda.title": "Jump Rope",
  "games.retos.cuerda.what": "Coordinación de pies e resistencia.",
  "games.retos.dom.metric": "Mejor racha",
  "games.retos.dom.skill": "Toque e control",
  "games.retos.dom.title": "Ball Juggling",
  "games.retos.dom.what": "Toque e control do balón.",
  "games.retos.eq.metric": "Sets superados",
  "games.retos.eq.skill": "Proprioception",
  "games.retos.eq.title": "Reto Equilibrio",
  "games.retos.eq.what": "Equilibrio e estabilidad de tobillo.",
  "games.retos.esc.metric": "Sets superados",
  "games.retos.esc.skill": "Foot quickness",
  "games.retos.esc.title": "Agility Ladder",
  "games.retos.esc.what": "Apoyos rápidos e frecuencia motriz.",
  "games.retos.finishSet": "Terminar Set ✔",
  "games.retos.lockedBtn": "Locked for today",
  "games.retos.pared.metric": "Pases totales",
  "games.retos.pared.skill": "Pase e pie malo",
  "games.retos.pared.title": "Wall Passes",
  "games.retos.pared.what": "Pase preciso e pie no dominante.",
  "games.retos.punt.metric": "Aciertos totales",
  "games.retos.punt.skill": "Passing accuracy",
  "games.retos.punt.title": "Cone Target",
  "games.retos.punt.what": "Long-distance passing accuracy.",
  "games.retos.questionTimer": "¿Lograste mantener ou ejercicio durante todo ou tiempo?",
  "games.retos.recommendedBadge": "Asignado",
  "games.retos.reg.metric": "Sets superados",
  "games.retos.reg.skill": "Ball handling",
  "games.retos.reg.title": "Dribbling Slalom",
  "games.retos.reg.what": "Conducción com obstáculos e cambio de ritmo.",
  "games.retos.repetitions": "{count} repeticiones",
  "games.retos.setHeader": "Set {current} of {total}",
  "games.retos.setsWord": "sets",
  "games.retos.startTimer": "Comenzar Tiempo",
  "games.retos.statSets": "Sets",
  "games.retos.statStatus": "Resultado",
  "games.retos.streakEnd": "Ball dropped / End of streak",
  "games.retos.timeExhausted": "Has alcanzado ou límite de 20 min de retos hoy. ¡Gran esfuerzo físico!",
  "games.retos.touchesStreak": "{count} toques seguidos",
  "games.safety.title": "Safety at Home",
  "games.status.notPlayed": "Sin registro",
  "games.status.practice": "Practice (unscored)",
  "games.tabs.cognitive": "Juegos Cognitivos (6)",
  "games.tabs.retos": "Home Challenges (8)",
  "games.timer.paused": "Pausado",
  "games.timer.remainingChip": "Restante hoy: {time}",
  "games.timer.setFinishing": "Final set",
  "gk.activeGoalkeeper": "GOALKEEPER ON PITCH",
  "gk.aerialClaim": "Saídas Aéreas",
  "gk.boxDominance": "Domínio de Área",
  "gk.btn.claim": "Salida / Rechace",
  "gk.btn.conceded": "Gol Encajado",
  "gk.btn.errorGoal": "Error Leading to Goal",
  "gk.btn.penaltySave": "Penalti Parado",
  "gk.btn.save": "Salvar",
  "gk.buildup": "Saída de Bola / Construção",
  "gk.claims": "Salidas e Despejes",
  "gk.claimsShort": "Salidas",
  "gk.cleanSheets": "Clean Sheets",
  "gk.cleanSheetsShort": "Invicto",
  "gk.conceded": "Goals Conceded",
  "gk.concededShort": "Enc.",
  "gk.diveLow": "Queda Rasteira",
  "gk.errorGoal": "Errors Leading to Goal",
  "gk.errorGoalShort": "Err. Gol",
  "gk.events.empty": "Sin intervenciones registradas para este partida.",
  "gk.events.list": "Goalkeeping Events",
  "gk.evolution": "Salvar % Evolution",
  "gk.history": "Jogo History",
  "gk.noActiveGoalkeeper": "Sin portero ativo en campo",
  "gk.parrySafe": "Espalmada Segura",
  "gk.penaltySaves": "Penaltis Parados",
  "gk.penaltySavesShort": "Pen. Par.",
  "gk.perMatch": "Por partida",
  "gk.rating": "GK Rating",
  "gk.reflexClose": "Reflexos à Queima-Roupa",
  "gk.role": "Goleiro",
  "gk.roleBadge": "🧤 Portero",
  "gk.saveHigh": "Defesa no Alto",
  "gk.savePercentage": "Salvar %",
  "gk.savePercentageShort": "Salvar %",
  "gk.saves": "Paradas",
  "gk.savesShort": "Par.",
  "gk.smother": "Dividida no Chão",
  "gk.suggest.confirm": "Yes, assign to goalkeeper",
  "gk.suggest.ignore": "No, solo registrar gol",
  "gk.suggest.message": "Se ha registrado um gol rival. ¿Deseas sumar 1 gol encajado al portero en campo ({name})?",
  "gk.suggest.title": "Assign conceded goal?",
  "gk.sweeper": "Goleiro Líbero",
  "gk.title": "Métricas Específicas de Goleiro",
  "gk.tooltip.claim": "Salida aérea, interceptación ou despeje de puños.",
  "gk.tooltip.cleanSheet": "Partido concluído com minutos jugados sem encajar gol.",
  "gk.tooltip.conceded": "Gol recibido mientras estuvo en a portería.",
  "gk.tooltip.errorGoal": "Fallo directo en posesión ou salida que desemboca en gol rival.",
  "gk.tooltip.penaltySave": "Pena máxima detenida durante ou encuentro.",
  "gk.tooltip.save": "Intervención exitosa que evita um gol rival.",
  "header.logoutConfirm": "¿Deseas fechar sessão ou cambiar de conta?",
  "header.switchPlayerPortal": "Switch to Jogador Portal",
  "health.active": "Activo",
  "health.addInjury": "+ Record Injury",
  "health.additionalNotes": "Notas Adicionais",
  "health.affectedArea": "Área Afetada *",
  "health.cancel": "Cancelar",
  "health.injuryDate": "Data da Lesão *",
  "health.injuryType": "Tipo de Lesão *",
  "health.markRecovered": "Marcar como Recuperado",
  "health.medicalNotes": "Observações Médicas",
  "health.medicalNotesPlaceholder": "Alergias, tratamentos contínuos, notas médicas...",
  "health.noInjuries": "Sin lesiones registradas.",
  "health.recordInjury": "Registrar Nova Lesão",
  "health.resolved": "Recuperado",
  "health.saveInjury": "Salvar Injury",
  "health.status.active": "Disponível / Ativo",
  "health.status.current": "Estado Atual",
  "health.status.injured": "Lesionado",
  "health.status.recovery": "Em Recuperação",
  "health.status.rest": "Descanso",
  "health.title": "Historial Médico e Lesiones",
  "health.updateStatus": "Atualizar Estado Geral",
  "ia.additionalObs": "Observaciones adicionales",
  "ia.age.alevin": "Under-12 (10-12)",
  "ia.age.amateur": "Amateur",
  "ia.age.base": "Grassroots (6-10 years)",
  "ia.age.cadete": "Cadete (14-16)",
  "ia.age.infantil": "Infantil (12-14)",
  "ia.age.juvenil": "Juvenil (16-18)",
  "ia.age.prebenjamin": "Under-10 (8-10)",
  "ia.animation": "Animation ({count}F)",
  "ia.btnClear": "🔄 Limpiar",
  "ia.btnExportPdf": "📄 Exportar PDF",
  "ia.btnGeneratePrevention": "🩺 Generate Exercício Plan",
  "ia.btnGenerateTactical": "✨ Generate Exercício",
  "ia.btnSave": "💾 Salvar",
  "ia.capture": "Captura",
  "ia.categoryAge": "CATEGORIA / IDADE",
  "ia.defaultTitle": "AI Exercício {time}",
  "ia.dictationNotSupported": "Tu navegador no soporta ou dictado por voz. Usa Chrome en Android para esta función.",
  "ia.dictationStart": "Voice dictation",
  "ia.dictationStop": "Detener dictado",
  "ia.drawerTitle": "☁️ Biblioteca Cloud",
  "ia.durationMinutes": "{count} min",
  "ia.emptyLibrary": "No saved exercises yet.",
  "ia.emptyPlaceholder": "Seu exercício aparecerá aqui",
  "ia.emptyResponse": "Respuesta vacía de a IA",
  "ia.intensityLabel": "Intensidade",
  "ia.level.advanced": "Avanzado",
  "ia.level.basic": "Basic",
  "ia.level.intermediate": "Intermedio",
  "ia.libraryBtn": "☁️ Biblioteca ({count})",
  "ia.limitReached": "Has alcanzado ou límite de {limit} generaciones de IA este mes. O límite se reinicia ou próximo mes.",
  "ia.listening": "🔴 Escuchando... habla ahora",
  "ia.loadingAnalyzing": "⏳ Analizando contexto...",
  "ia.loadingGenerating": "Generando...",
  "ia.loadingUsage": "🔑 IA: Cargando usos...",
  "ia.mainObjective": "OBJETIVO PRINCIPAL",
  "ia.mat.balls": "Bolas",
  "ia.mat.bibs": "Coletes",
  "ia.mat.cones": "Cones",
  "ia.mat.goals": "Gols",
  "ia.mat.hurdles": "Barreiras",
  "ia.mat.ladder": "Escada de agilidade",
  "ia.mat.none": "No specific equipment",
  "ia.mat.rings": "Aros",
  "ia.materials": "MATERIAIS",
  "ia.modalDetail": "Detalle",
  "ia.modalLoad": "Cargar",
  "ia.modalNoContent": "Sin contenido.",
  "ia.modalOpenBoard": "Open in Board",
  "ia.modePrevention": "Prevenção /\nRecuperação",
  "ia.modeTactical": "Exercício\nTático",
  "ia.noRef": "Sin Ref.",
  "ia.numPlayers": "Nº DE JOGADORES: {count}",
  "ia.obj.aerobic": "Aerobic endurance",
  "ia.obj.agility": "Agilidad e coordinación",
  "ia.obj.cooldown": "Volta à calma",
  "ia.obj.crossing": "Centros e llegadas",
  "ia.obj.finishing": "Finalización e remate",
  "ia.obj.positional": "Positional play",
  "ia.obj.possession": "Posessão de balón",
  "ia.obj.pressing": "Presión e pressing",
  "ia.obj.speed": "Velocidade",
  "ia.obj.strength": "Fuerza e potencia",
  "ia.obj.transAttDef": "Transition attack-to-defense",
  "ia.obj.transDefAtt": "Transition defense-to-attack",
  "ia.obj.warmup": "Aquecimento",
  "ia.obsPlaceholder": "Ej. Enfocarse en a velocidad de ejecución ou en ou repliegue defensivo...",
  "ia.phaseLabel": "Fase de jogo",
  "ia.prev.availableMaterial": "Material Disponible",
  "ia.prev.bodyZone": "Zona Corporal",
  "ia.prev.descLabel": "Clinical Description / Problem",
  "ia.prev.descPlaceholder": "Ej: Jugador de 16 años com sobrecarga isquiotibial izquierdo tras partida, necesita ejercicios excéntricos e de fortalecimiento...",
  "ia.prev.noMaterial": "Sin material",
  "ia.prev.planType": "Plan Type",
  "ia.prev.playerLevel": "Jogador Level",
  "ia.prev.typePrevention": "Prevention",
  "ia.prev.typeReadaptation": "Readaptation",
  "ia.prev.typeRecovery": "Recovery",
  "ia.recoveryNotice": "Sessão focada em regeneração muscular e prevenção.",
  "ia.saveError": "Error al salvar ou ejercicio. Intenta de nuevo.",
  "ia.saveSuccess": "✅ Guardado en a biblioteca: \"{title}\"",
  "ia.selectPlaceholder": "Selecionar...",
  "ia.space": "Espacio",
  "ia.space.box": "Penalty area",
  "ia.space.full": "Campo completo",
  "ia.space.gym": "Sala / Gimnasio",
  "ia.space.half": "Medio campo",
  "ia.space.small": "Espacio reducido",
  "ia.space.threeQuarter": "3/4 campo",
  "ia.subtitle": "DESIGN INTELIGENTE DE SESSÕES DE TREINO",
  "ia.tacticalBoard": "🎬 Pizarra",
  "ia.tacticalRef": "Tactical Reference (Optional)",
  "ia.title": "Assistente Tático de IA",
  "ia.usageRemaining": "🔑 AI: you have {count} uses left this month (limit {limit})",
  "ia.validationPrevention": "Por favor describe ou caso e selecciona uma zona corporal.",
  "ia.validationTactical": "Por favor completa: Edad, Objetivo e Espacio.",
  "ia.zone.adductors": "Aductores",
  "ia.zone.ankle": "Tobillo",
  "ia.zone.calves": "Gemelos",
  "ia.zone.core": "Core / Pelvis",
  "ia.zone.hamstring": "Isquiotibial",
  "ia.zone.knee": "Rodilla",
  "ia.zone.lumbar": "Lumbar",
  "ia.zone.quadriceps": "Quadriceps",
  "ia.zone.shoulder": "Hombro",
  "install.alreadyInstalled": "¡A App já está instalada en tu dispositivo!",
  "install.androidDesc": "Pulsa ou botón \"Instalar ahora\" abajo ou usa ou menú de tres puntos (⋮) e elige \"Instalar aplicación\".",
  "install.androidTitle": "Android (Navegador Chrome):",
  "install.btnInstall": "Instalar ahora",
  "install.fallbackNotice": "Si no ves ou botón de instalación, usa a opción \"Añadir a pantalla de inicio\" de tu navegador.",
  "install.instructions": "Instrucciones:",
  "install.iosDesc": "Pulsa ou botón \"Compartir\" (cuadrado com flecha) e selecciona \"Añadir a a pantalla de inicio\".",
  "install.iosTitle": "iOS (Safari):",
  "install.metaDesc": "Instrucciones de instalación paso a paso de a aplicación PWA Mister11 para dispositivos Android e iOS.",
  "install.metaTitle": "Instalar Mister11 — A App de Fútbol para Entrenadores",
  "install.slogan": "O banquillo en tu bolsillo",
  "install.title": "Instalar Aplicativo Mister11",
  "invite.already_registered": "Este correo já está registrado ou invitado en ou club.",
  "invite.coach.codePlaceholder": "Invitation code (6 characters)",
  "invite.coach.scanQR": "Scan invitation QR",
  "invite.coach.title": "Entrar como Treinador / Staff",
  "invite.generated_error": "Error al generar a invitación.",
  "invite.generated_success": "Invitación generada com éxito.",
  "invite.link_copied": "Link copied!",
  "invite.player.codePlaceholder": "Time code",
  "invite.player.scanQR": "Escanear QR del time",
  "invite.player.title": "Join Your Time",
  "joinTeam.account_created": "Cuenta creada exitosamente",
  "joinTeam.already_member": "¡Ya formas parte de este time! Cargando tu portal...",
  "joinTeam.google_sign_in": "Sesión iniciada com Google",
  "joinTeam.request_approved": "Your request has been approved!",
  "joinTeam.request_sent": "Request sent to the coach!",
  "joinTeam.welcome": "Bienvenido a Mister11",
  "live.action.foul": "Falta",
  "live.action.goal": "Gol",
  "live.action.offside": "Impedimento",
  "live.action.recovery": "Recuperação",
  "live.action.redCard": "Cartão Vermelho",
  "live.action.shot": "Finalização",
  "live.action.turnover": "Perda de bola",
  "live.action.yellowCard": "Cartão Amarelo",
  "live.btn.card_red_own": "Roja (Propia)",
  "live.btn.card_red_rival": "Roja (Rival)",
  "live.btn.card_yellow_own": "Amarilla (Propia)",
  "live.btn.card_yellow_rival": "Amarilla (Rival)",
  "live.btn.corner_against": "Corner Against",
  "live.btn.corner_favor": "Corner in Favor",
  "live.btn.counter_not_cut": "Contra No Cortada",
  "live.btn.duel_lost": "Duelo Perdido",
  "live.btn.duel_won": "Duelo Ganado",
  "live.btn.foul_against": "Foul Against",
  "live.btn.foul_favor": "Falta a Favor",
  "live.btn.loss": "Perda de Bola",
  "live.btn.offside_own": "Offside (Own)",
  "live.btn.offside_rival": "Offside (Opponent)",
  "live.btn.player_no_finish": "Jugada No Finalizada",
  "live.btn.recovery": "Recuperação",
  "live.btn.save_own": "Goalkeeper Salvar (Own)",
  "live.btn.save_rival": "Goalkeeper Salvar (Opponent)",
  "live.btn.shot_off_own": "Tiro Fuera (Propio)",
  "live.btn.shot_off_rival": "Tiro Fuera (Rival)",
  "live.btn.shot_on_own": "Tiro a Puerta (Propio)",
  "live.btn.shot_on_rival": "Tiro a Puerta (Rival)",
  "live.tab.analytics": "Advanced Analysis",
  "live.tab.capture": "Live Capture",
  "live.tab.players": "Jogadores & CSV",
  "live.tab.tactical": "Field & Tactics",
  "liveStats.quickMode.advanced": "Opciones avanzadas",
  "liveStats.quickMode.shotSaved": "Tiro registrado",
  "liveStats.quickMode.simple": "Modo simple",
  "liveStats.quickMode.title": "Quick Mode",
  "liveStats.quickMode.undo": "Deshacer",
  "liveStats.quickMode.undone": "Tiro deshecho",
  "livestats.match_locked_short": "⚠️ Match completed",
  "livestats.match_locked_use_reopen": "⚠️ Match completed — use Reopen Match Sheet to correct.",
  "livestats.post_match_saved": "✅ Contadores post-partida guardados",
  "livestats.select_player_first": "👆 Selecione um jogador primeiro",
  "login.account_created": "Account created successfully!",
  "login.cancelled": "Inicio de sessão cancelado por ou usuario",
  "login.recovery_error": "Error sending email",
  "login.recovery_sent": "Recovery link sent to your email",
  "login.welcome": "Welcome to Mister11!",
  "login.write_email_first": "Escribe tu correo primero",
  "match.btn.exportIcs": "EXPORTAR ICS",
  "match.btn.newMatch": "+ NOVA PARTIDA",
  "match.btn.pdfCalendar": "CALENDÁRIO PDF",
  "match.defaultMyTeam": "Meu Time",
  "match.defaultRival": "Adversário",
  "match.filter.all": "Todos",
  "match.filter.finished": "Finalizadas",
  "match.filter.pending": "Pendentes",
  "match.formationLabel": "Formação: ",
  "match.locked_reopen": "⚠️ Partido finalizado. Reabre ou acta para registrar eventos.",
  "match.management.title": "GESTÃO DE PARTIDAS",
  "match.noVenue": "Sem local",
  "match.sort.cercania": "Mais próxima de hoje",
  "match.sort.estado": "Por Status / Prioridade",
  "match.sort.fecha_asc": "Data (Próximas)",
  "match.sort.fecha_desc": "Data (Recentes)",
  "match.sort.label": "Ordenar por",
  "match.sort.lejania": "Mais distante de hoje",
  "match.status.en_edicion": "EM EDIÇÃO",
  "match.status.finalizado": "FINALIZADO",
  "match.status.no_disputado": "NÃO DISPUTADO",
  "match.status.pendiente": "PENDENTE",
  "match.venue.local": "Campo Mandante",
  "match.venue.municipal": "Estádio Municipal",
  "match.view.cards": "Cartões",
  "match.view.detailed": "Detalhado",
  "matchSheet.anomalies_resolved": "✔ {count} anomalía(s) resuelta(s) e acta sincronizada.",
  "matchSheet.auto_badge": "Auto",
  "matchSheet.close_error": "❌ Error al fechar ou acta. Intenta de nuevo.",
  "matchSheet.closed_success": "✅ Match sheet closed. Real minutes saved.",
  "matchSheet.closed_with_warnings": "⚠️ Acta cerrada com avisos registrados.",
  "matchSheet.confirm_save_btn": "💾 CONFIRM & SAVE SHEET",
  "matchSheet.confirm_save_tooltip": "Salvar all manual minute corrections and update the official match sheet",
  "matchSheet.log_already_clean": "✨ A bitácora já está limpia. Cero eventos imposibles.",
  "matchSheet.log_debug_error": "❌ Error debugging log.",
  "matchSheet.manual_allowed_closed": "allowed even when closed",
  "matchSheet.manual_badge": "Manual",
  "matchSheet.manual_override_title": "Manual minutes override",
  "matchSheet.prefill_rsvp_empty": "No hay respuestas RSVP pendentes para prellenar.",
  "matchSheet.prefill_rsvp_error": "❌ Error pre-filling from RSVP.",
  "matchSheet.prefill_rsvp_success": "✅ Estados prellenados desde RSVP.",
  "matchSheet.prefill_smart_error": "❌ Error in smart pre-filling.",
  "matchSheet.prefill_smart_success": "⚡ Acta prellenada inteligentemente desde alineación e eventos.",
  "matchSheet.referee": "Árbitro",
  "matchSheet.reopen_error": "❌ Error al reabrir ou acta.",
  "matchSheet.reopened_info": "🔓 Acta e partida reabiertos para correcciones.",
  "matchSheet.saving": "💾 Guardando...",
  "matchSheet.signatures": "Assinaturas Oficiais",
  "matchSheet.tactical_grade_saved": "⭐ Calificación táctica salva",
  "matchSheet.weather": "Clima / Gramado",
  "matches.finish_error": "❌ Error al salvar finalización:",
  "matches.lineup.benchTitle": "SUBSTITUTES BENCH",
  "matches.lineup.downloadPng": "DESCARGAR PNG",
  "matches.lineup.emptySlot": "Empty",
  "matches.lineup.exportingPng": "EXPORTANDO...",
  "matches.lineup.subtitle": "Pizarra gráfica com once titular e banquillo de suplentes",
  "matches.lineup.title": "Alineación Táctica e Banquillo",
  "matches.log_cleanse_error": "❌ Error al depurar a bitácora.",
  "matches.log_cleansed": "🧹 Bitácora depurada com éxito. {count} registros saneados.",
  "matches.repair_error": "❌ Error al reparar ou partida.",
  "matches.repaired": "✅ Partido reparado e persistido com éxito.",
  "matches.warnings.auditHide": "Hide audit",
  "matches.warnings.auditNote": "Bitácora depurada ou {date}: {count} anomalías aisladas e resueltas.",
  "matches.warnings.auditShow": "Ver detalle",
  "matches.warnings.bannerTitle": "Este partida contenía {count} anomalías ou dados legacy aislados automáticamente.",
  "matches.warnings.chipTooltip": "{count} anomalías detectadas en bitácora (clic para ver e resolver en Acta Oficial)",
  "matches.warnings.cleanseBtn": "Cleanse & Resolve",
  "matches.warnings.cleansing": "Depurando...",
  "matches.warnings.hideDetails": "Ocultar detalles",
  "matches.warnings.resolvedSuccess": "✔ {count} anomalía(s) resuelta(s) e acta sincronizada.",
  "matches.warnings.showDetails": "Ver lista",
  "month.Abr": "Abr",
  "month.Ago": "Ago",
  "month.Dic": "Dez",
  "month.Ene": "Jan",
  "month.Feb": "Fev",
  "month.Jul": "Jul",
  "month.Jun": "Jun",
  "month.Mar": "Mar",
  "month.May": "Mai",
  "month.Nov": "Nov",
  "month.Oct": "Out",
  "month.Sep": "Set",
  "nav.admin": "ADMINISTRAÇÃO",
  "nav.dashboard": "PAINEL DE CONTROLE",
  "nav.equipo": "MEU TIME",
  "nav.ia": "IA GERADORA",
  "nav.partidos": "JOGOS",
  "nav.pizarra": "QUADRO TÁTICO",
  "nav.planificacion": "PLANEJAMENTO",
  "nav.sesiones": "SESSÕES",
  "nav.tests": "TESTES",
  "notifPrefs.chatDesc": "Avisos de nuevos mensajes en ou chat de a plantilla",
  "notifPrefs.chatTitle": "Time Messages",
  "notifPrefs.errorToast": "Error al salvar as preferencias de notificación",
  "notifPrefs.frequencyCapDesc": "Número máximo de notificações diarias",
  "notifPrefs.frequencyCapTitle": "Frequency Cap",
  "notifPrefs.matchDesc": "Alertas sobre convocatorias, horarios e partidas próximos",
  "notifPrefs.matchTitle": "Convocatorias e Partidos",
  "notifPrefs.perDay": "per day",
  "notifPrefs.quietHoursDesc": "No recibir notificações push en esta franja horaria",
  "notifPrefs.quietHoursEnd": "Quiet end time",
  "notifPrefs.quietHoursStart": "Quiet start time",
  "notifPrefs.quietHoursTitle": "Quiet Hours",
  "notifPrefs.reminderTime": "Horário do lembrete",
  "notifPrefs.savedToast": "Preferencias de notificación guardadas com éxito",
  "notifPrefs.title": "Preferências de Notificação",
  "notifPrefs.wellnessDesc": "Recordatorio diario para completar ou formulario de salud",
  "notifPrefs.wellnessTitle": "Wellness Check-in",
  "notifications.empty": "Você não tem notificações pendentes.",
  "notifications.individualPlanAssigned": "Plano individual atribuído com sucesso",
  "notifications.individualPlanRemoved": "Plano individual removido",
  "notifications.newExerciseSaved": "Novo exercício salvo: {name}",
  "notifications.newMatchRegistered": "Nova partida registrada contra {opponent}",
  "notifications.newPlayerAdded": "Novo jogador adicionado: {name}",
  "notifications.newSessionCreated": "Nova sessão criada: {title}",
  "notifications.predefinedExerciseError": "Você não pode excluir um exercício predefinido do sistema.",
  "notifications.sessionImportedSuccess": "Sessão \"{title}\" imported successfully",
  "notifications.teamPlanAssigned": "Plano de equipe atribuído com sucesso",
  "notifications.teamPlanRemoved": "Plano de equipe removido",
  "notifications.timeHoursAgo": "Há {hours} horas",
  "notifications.timeJustNow": "Agora mesmo",
  "notifications.timeMinAgo": "Há {min} min",
  "notifications.timeNow": "Agora",
  "notifications.title": "Notificações",
  "notifications.weeklyReportReady": "📋 Your weekly team report is ready. Baixar it from the main panel!",
  "page.admin": "ADMINISTRAÇÃO",
  "page.dashboard": "PAINEL DE CONTROLE",
  "page.default": "Mister11",
  "page.equipo": "MEU TIME",
  "page.ia": "IA GERADORA",
  "page.partidos": "JOGOS",
  "page.pizarra": "QUADRO TÁTICO",
  "page.planificacion": "PLANEJAMENTO",
  "page.sesiones": "SESSÕES",
  "page.tests": "TESTES",
  "partidos.tab.analisis": "Análise",
  "partidos.tab.lista": "Partidas",
  "paywall.androidBackToInfo": "Voltar",
  "paywall.androidDialogText": "A suscripción se gestiona de forma centralizada desde nuestra plataforma web. Visita mister11.app para contratar tu plan e recibe ou acceso al instante en esta app.",
  "paywall.androidDialogTitle": "Planes Mister11 PRO",
  "paywall.androidHaveCode": "Ya tengo um código",
  "paywall.androidNotNow": "Agora não",
  "paywall.androidOpenWeb": "Abrir mister11.app",
  "paywall.androidRedeemDesc": "Introduce tu código corporativo ou promocional para activar tu plan PRO al instante.",
  "paywall.androidRedeemTitle": "Resgatar Código",
  "paywall.benefit1": "Sesiones de treinamento ilimitadas",
  "paywall.benefit2": "Unlimited AI task generator",
  "paywall.benefit3": "Exportar technical reports in PDF",
  "paywall.benefit4": "Suite avanzada de estadísticas e métricas",
  "paywall.clubBadge": "PLANO CLUBE",
  "paywall.freeLimitMsg": "Has alcanzado ou límite do plan gratuito.",
  "paywall.proBadge": "PLANO PRO",
  "paywall.promoPlaceholder": "Code (e.g. BETA2026)",
  "paywall.promoSectionDesc": "Introduce tu código (ej. BETA2026) para activar ou acceso inmediatamente.",
  "paywall.promoSectionTitle": "🔑 Tem um código promocional ou de teste beta?",
  "paywall.title": "Desbloqueie o Mister11 Pro",
  "paywall.upgradeBtn": "OBTER PLANO PRO",
  "paywall.upgradeClubBtn": "Ver Planos CLUBE",
  "placeholder.teamName": "Ej. Rayo Vallecano Juvenil A",
  "plan.category": "CATEGORIA",
  "plan.categoryPlaceholder": "Ex: Infantil A",
  "plan.chip.compet": "Compet.",
  "plan.chip.sessions": "Sessões",
  "plan.chip.work": "Trabalho",
  "plan.coach": "TREINADOR",
  "plan.coachPlaceholder": "Nome do treinador",
  "plan.dateRange": "INTERVALO DE DATAS",
  "plan.days.friday": "F",
  "plan.days.monday": "M",
  "plan.days.saturday": "S",
  "plan.days.sunday": "S",
  "plan.days.thursday": "T",
  "plan.days.tuesday": "T",
  "plan.days.wednesday": "W",
  "plan.end": "Fim",
  "plan.exportPdf": "EXPORTAR PDF",
  "plan.fatigaWarning": "⚠️ Treino em MD-1 — fadiga potencial",
  "plan.matchDay": "⚽ Dia de Jogo:",
  "plan.meso.backToMeso": "← Voltar aos Mesociclos",
  "plan.meso.competition": "COMPETIÇÃO",
  "plan.meso.exportPdf": "Exportar mês para PDF",
  "plan.meso.load": "CARGA",
  "plan.meso.month": "MÊS",
  "plan.meso.monthDetail": "Detalhe do Mês: ",
  "plan.meso.predominantType": "TIPO PREDOMINANTE",
  "plan.meso.sessions": "SESSÕES",
  "plan.meso.totalVolume": "VOLUME TOTAL",
  "plan.meso.weeks": "Semanas",
  "plan.metricSessions": "SESSÕES",
  "plan.metrics.macrocycle": "MACROCICLO",
  "plan.metrics.mesocycle": "MESOCICLO",
  "plan.metrics.mesocyclesOverview": "MESOCICLOS (VISÃO GERAL)",
  "plan.micro.matchDayLabel": "🏆 Dia de Jogo",
  "plan.micro.physical": "Físico",
  "plan.micro.rest": "Descanso",
  "plan.micro.selectWeek": "SELECIONAR SEMANA",
  "plan.micro.sessionLabel": "Sessão ({duration} min)",
  "plan.micro.tactical": "Tático",
  "plan.micro.technical": "Técnico",
  "plan.micro.week": "Semana",
  "plan.obj.mental": "OBJETIVO MENTAL",
  "plan.obj.mentalPlaceholder": "Desenvolver a concentração e o trabalho em equipe...",
  "plan.obj.physical": "OBJETIVO FÍSICO",
  "plan.obj.physicalPlaceholder": "Melhorar a resistência aeróbica e a velocidade de reação...",
  "plan.obj.seasonGeneral": "OBJETIVO GERAL DA TEMPORADA",
  "plan.obj.seasonGeneralPlaceholder": "Descreva o objetivo principal da temporada...",
  "plan.obj.tactical": "OBJETIVO TÁTICO",
  "plan.obj.tacticalPlaceholder": "Dominar a pressão alta e a saída de bola...",
  "plan.obj.technical": "OBJETIVO TÉCNICO",
  "plan.obj.technicalPlaceholder": "Melhorar o controle e o passe em espaços reduzidos...",
  "plan.pdf.error": "Erro ao exportar PDF.",
  "plan.pdf.exported": "PDF exportado ✓",
  "plan.period.comp": "Comp",
  "plan.period.prep": "Prep",
  "plan.period.trans": "Trans",
  "plan.reschedule.body": "O dia de jogo selecionado para esta semana é {day}. Ao confirmar, os {count} dias de treino serão ajustados automaticamente para equilibrar a carga antes da partida.",
  "plan.reschedule.confirm": "Confirmar Reagendamento",
  "plan.reschedule.title": "Reagendar dias de treino?",
  "plan.reschedule.toastSuccess": "✓ Treinos reagendados com base no dia do jogo",
  "plan.reubicarBtn": "🔄 Reorganizar treinos conforme novo dia",
  "plan.save": "SALVAR",
  "plan.saving": "SALVANDO...",
  "plan.seasonObjective": "OBJETIVO GERAL DA TEMPORADA",
  "plan.seasonObjectivePlaceholder": "Digite o objetivo geral da temporada...",
  "plan.seasonVolume": "VOLUME DA TEMPORADA",
  "plan.sessionDuration": "Duração da sessão:",
  "plan.start": "Início",
  "plan.strategicPlanning": "PLANEJAMENTO ESTRATÉGICO",
  "plan.tab.macrociclo": "MACROCICLO",
  "plan.tab.mesociclo": "MESOCICLO",
  "plan.tab.microciclo": "MICROCICLO",
  "plan.tab.objetivos": "OBJETIVOS",
  "plan.totalMinutesLabel": "minutos totais",
  "plan.trainingDays": "DIAS DE TREINAMENTO",
  "plan.volumeUnit": "min/sem",
  "planning.generating_pdf": "Gerando PDF do mesociclo...",
  "planning.generating_pdf_generic": "Generando PDF...",
  "planning.login_required": "Inicie a sessão para salvar",
  "planning.matrix.daysPerWeek": "dias/sem",
  "planning.matrix.loadDynamics": "DINÂMICA DE CARGA",
  "planning.matrix.matchDay": "DIA DE JOGO",
  "planning.matrix.microType": "TIPO MICRO",
  "planning.matrix.microcycleNo": "Nº MICROCICLO",
  "planning.matrix.months": "MESES",
  "planning.matrix.pctPhysical": "% FÍSICO",
  "planning.matrix.pctTactical": "% TÁTICO",
  "planning.matrix.pctTechnical": "% TÉCNICO",
  "planning.matrix.periods": "PERÍODOS",
  "planning.matrix.physicalTest": "TESTE FÍSICO",
  "planning.matrix.savePlanning": "SALVAR PLANEJAMENTO",
  "planning.matrix.sessions": "SESSÕES",
  "planning.matrix.title": "MATRIZ DE PLANEJAMENTO",
  "planning.matrix.volumeMin": "VOLUME (MIN)",
  "planning.microType.ajuste": "Ajuste",
  "planning.microType.carga": "Carga",
  "planning.microType.choque": "Choque",
  "planning.microType.comp": "Comp",
  "planning.microType.recup": "Recup",
  "planning.pdf_error": "Error exporting PDF.",
  "planning.pdf_exported": "PDF exportado ✓",
  "planning.pdf_month_not_found": "Error: No se encontró a informação do mes.",
  "planning.pdf_success": "PDF do mesociclo generado com éxito ✓",
  "planning.save_error": "Error al salvar.",
  "planning.saved": "Planificación salva ✓",
  "plans.assignModal.ageBlocked": "Não adequado para a idade do jogador",
  "plans.assignModal.assignBtn": "Atribuir Plano",
  "plans.assignModal.frequency": "Frequência",
  "plans.assignModal.homeAlternative": "Alternativa caseira",
  "plans.assignModal.minAge": "Idade mín. segura",
  "plans.assignModal.planName": "Nome do Plano (opcional)",
  "plans.assignModal.preferredMaterial": "Material preferido",
  "plans.assignModal.reason": "Motivo",
  "plans.assignModal.searchPlaceholder": "Buscar exercício...",
  "plans.assignModal.selectExercises": "Selecionar Exercícios",
  "plans.assignModal.supervisionRequired": "Requer supervisão presencial",
    "exercise.illustrationPending": "Ilustração pendente — siga a descrição textual",
  "exercise.illustrationNotice": "Protocolo clínico: validação técnica visual em andamento sem geração sintética",
  "exercise.coachingPoints": "Pontos-chave de execução",
  "exercise.minSafeAge": "Idade mín. segura",
  "exercise.preferredMaterial": "Material preferido",
  "exercise.homeAlternative": "Alternativa caseira",
  "exercise.supervisionRequired": "Requer supervisão presencial",
  "plans.assignModal.title": "Atribuir Plano de Exercícios",
  "plans.assignedPlan": "Plano Atribuído",
  "plans.badgeIndividual": "INDIVIDUAL",
  "plans.badgeTeam": "TEAM",
  "plans.coachFeedback": "Instrucciones do Míster",
  "plans.copyLink": "COPIAR LINK",
  "plans.daily": "Diário",
  "plans.exercisesHeader": "Today's Exercícios",
  "plans.linkCopied": "LINK COPIADO!",
  "plans.loadingPlans": "Cargando planes...",
  "plans.noPlansAssigned": "O jogador no tiene planes asignados.",
  "plans.recommendExercises": "Recommend Exercícios",
  "plans.routinesAndPrevention": "Rutinas e Prevención",
  "plans.shareNotice": "Compartilhe este link com seus jogadores para que eles possam ver o plano de exercícios sem fazer login:",
  "plans.sharePlan": "🔗 Compartir Plan",
  "plans.streakDays.one": "Streak: {count} day",
  "plans.streakDays.other": "Streak: {count} days",
  "player.achievements.bronzeBadge": "25 XP · Desafio Semanal",
  "player.achievements.completed": "Concluído!",
  "player.achievements.filterAll": "Todas ({count})",
  "player.achievements.filterBiweekly": "Quinzenais (Prata)",
  "player.achievements.filterBronze": "Bronze ({count})",
  "player.achievements.filterGold": "Ouro ({count})",
  "player.achievements.filterSeason": "Temporada (Ouro)",
  "player.achievements.filterSilver": "Prata ({count})",
  "player.achievements.filterWeekly": "Semanais (Bronze)",
  "player.achievements.goldBadge": "100 XP · Marco de Temporada (Máx.)",
  "player.achievements.inProgress": "{percent}% concluído",
  "player.achievements.intentionOnlyNote": "(Desafio de intenção)",
  "player.achievements.loading": "Carregando vitrine de conquistas...",
  "player.achievements.noSessions": "Sem sessões programadas esta semana",
  "player.achievements.pendingActa": "Súmula pendente",
  "player.achievements.season": "Temporada 2026-27 · Futebol de Base",
  "player.achievements.seasonPeriod": "Temporada 2026-27",
  "player.achievements.silverBadge": "50 XP · Desafio Quinzenal",
  "player.achievements.subtabJuegos": "Jogos e Desafios",
  "player.achievements.subtabRanking": "Ranking",
  "player.achievements.subtabVitrina": "Vitrine",
  "player.achievements.thisFortnight": "Esta quinzena",
  "player.achievements.thisWeek": "Esta semana",
  "player.achievements.tierBronze": "Bronze",
  "player.achievements.tierGold": "Ouro",
  "player.achievements.tierSilver": "Prata",
  "player.achievements.title": "Suas Conquistas Esportivas",
  "player.achievements.titleParent": "Conquistas de {name}",
  "player.achievements.unlocked": "Desbloqueados",
  "player.achievements.xpSubtitle": "Ganha ao desbloquear desafios",
  "player.achievements.xpTitle": "XP de Conquistas",
  "player.addPlayer": "+ Add Jogador",
  "player.age": "Idade",
  "player.assists": "Asistencias",
  "player.attendance.absent": "Ausente",
  "player.attendance.excused": "Justificado",
  "player.attendance.injured": "Lesionado",
  "player.attendance.monthlyTitle": "Monthly Attendance Record",
  "player.attendance.present": "Presente",
  "player.attendance.rate": "Annual Attendance Rate",
  "player.avgRating": "Nota Média",
  "player.bmi": "IMC",
  "player.bothFeet": "Ambidestro",
  "player.cards": "Tarjetas",
  "player.category": "Categoria",
  "player.chat.block.btn": "Yes, Block",
  "player.chat.block.confirm": "¿Seguro que deseas bloquear a comunicación com {name}? No podrán enviarse mensajes en este canal privado hasta que lo desbloquees.",
  "player.chat.block.success": "Usuario bloqueado correctamente.",
  "player.chat.block.title": "Block user?",
  "player.chat.block_error": "Error blocking user.",
  "player.chat.blocked.banner": "🚫 A comunicación en este chat privado está bloqueada.",
  "player.chat.blocked.unblockHint": "Puedes gestionar os usuarios bloqueados desde Perfil > Privacidad.",
  "player.chat.coachSender": "👑 Coaching Staff",
  "player.chat.emptyDesc": "Escribe um mensaje ou pulsa uma de as opciones rápidas arriba.",
  "player.chat.emptyTitle": "No messages in this channel yet.",
  "player.chat.headerSubtitle": "{team} · Mensajes privados e confidenciales",
  "player.chat.headerTitle": "Canal Directo com ou Cuerpo Técnico",
  "player.chat.loading": "Loading conversation...",
  "player.chat.menu.block": "Bloquear usuario",
  "player.chat.menu.copied": "Text copied to clipboard",
  "player.chat.menu.copy": "Copiar texto",
  "player.chat.menu.report": "Denunciar mensaje",
  "player.chat.moderation.badge": "Reportes",
  "player.chat.moderation.deleteConfirm": "¿Eliminar este mensaje definitivamente do chat?",
  "player.chat.moderation.deleteMsg": "Excluir message",
  "player.chat.moderation.empty": "No hay mensajes denunciados pendentes de revisión.",
  "player.chat.moderation.msgDeleted": "Mensaje excluído do chat.",
  "player.chat.moderation.resolve": "Marcar como resuelto",
  "player.chat.moderation.resolved": "Reporte resuelto.",
  "player.chat.moderation.title": "Message Moderation",
  "player.chat.now": "Ahora",
  "player.chat.optionsAria": "Opções da mensagem",
  "player.chat.placeholder": "Escribe um mensaje al míster...",
  "player.chat.placeholderCoach": "Escribe uma respuesta a {name}...",
  "player.chat.playerSender": "👤 Jogador",
  "player.chat.qr.coachEarly": "⏰ Remember to arrive 15 min early",
  "player.chat.qr.coachReceived": "👍 Recibido, nos vemos en ou campo",
  "player.chat.qr.coachRest": "🩺 Descansa e avísame si persiste ou dolor",
  "player.chat.qr.coachSquad": "📋 Squad confirmed, all the best!",
  "player.chat.qr.discomfort": "🩺 Tengo molestia muscular",
  "player.chat.qr.late10": "🏃 Llego 10 min tarde",
  "player.chat.qr.ready": "✅ Todo listo para ou partida",
  "player.chat.qr.talk": "❓ Coach, can I speak with you?",
  "player.chat.qr.transport": "🚗 Necesito transporte para ou desplazamiento",
  "player.chat.quickMsg.injury": "Tengo uma molestia muscular e no podré entrenar al 100%.",
  "player.chat.quickMsg.late": "I will be 5 minutes late.",
  "player.chat.quickMsg.ready": "¡Listo para ou partida do fin de semana!",
  "player.chat.quickMsg.study": "I cannot attend due to study / exam commitments.",
  "player.chat.quickReplies": "⚡ Quick replies:",
  "player.chat.quickTitle": "Quick Messages:",
  "player.chat.report.detailsPlaceholder": "Add any additional details (optional)...",
  "player.chat.report.quotedMessage": "Mensaje denunciado:",
  "player.chat.report.reason.harassment": "Acoso, intimidación ou conducta indebida",
  "player.chat.report.reason.inappropriate": "Contenido inapropiado ou lenguaje ofensivo",
  "player.chat.report.reason.other": "Otro motivo",
  "player.chat.report.reason.spam": "Spam ou mensajes no deseados",
  "player.chat.report.selectReason": "Selecione o motivo:",
  "player.chat.report.submit": "Enviar Denuncia",
  "player.chat.report.submitting": "Enviando...",
  "player.chat.report.subtitle": "Revisamos todas as denuncias para garantizar um entorno seguro e respetuoso.",
  "player.chat.report.success": "Denuncia enviada correctamente. O cuerpo técnico revisará ou mensaje.",
  "player.chat.report.title": "Denunciar Mensaje",
  "player.chat.report_error": "Error al enviar a denuncia.",
  "player.chat.send": "Enviar",
  "player.chat.sendAria": "Enviar mensaje",
  "player.chat.title": "Chat with Coach",
  "player.chat.unblock.btn": "Desbloquear",
  "player.chat.unblock.confirm": "¿Deseas desbloquear a {name} e reanudar a mensajería?",
  "player.chat.unblock.success": "Usuario desbloqueado.",
  "player.closeProfile": "Fechar profile",
  "player.coachRating": "Coach Rating",
  "player.deleteConfirm": "Tem certeza de que deseja remover este jogador do elenco?",
  "player.deleteFromTeam": "Remover {name} do Time",
  "player.editProfile": "Editar Profile",
  "player.foot": "Pé dominante",
  "player.foot.both": "Ambidestro",
  "player.foot.left": "Canhoto",
  "player.foot.right": "Destro",
  "player.goalAbbr": "GOL",
  "player.goals": "GOLS",
  "player.height": "Altura",
  "player.heightAbbr": "Alt",
  "player.home.almostBronze": "CONQUISTA QUASE ALCANÇADA! (BRONZE)",
  "player.home.almostGold": "CONQUISTA QUASE ALCANÇADA! (OURO)",
  "player.home.almostSilver": "CONQUISTA QUASE ALCANÇADA! (PRATA)",
  "player.home.announcements": "Time Notice Board",
  "player.home.closestAchievement": "Next Challenge",
  "player.home.goals": "MATCH GOALS",
  "player.home.goalsSub": "{goals} in {matches} ({minutes}')",
  "player.home.goalsSummary": "{goals} in {matches} ({minutes}')",
  "player.home.greeting": "Olá, {name}!",
  "player.home.nextChallenge": "NEXT CHALLENGE",
  "player.home.nextEventBadge": "NEXT CALL-UP",
  "player.home.nextMatch": "Next Call-up",
  "player.home.noAnnouncements": "Não há avisos recentes do treinador.",
  "player.home.noUpcoming": "Não há treinos programados para os próximos dias.",
  "player.home.rsvpBtn": "Confirmar Attendance (RSVP)",
  "player.home.rsvpPrompt": "Você participará desta sessão?",
  "player.home.scheduled": "PROGRAMADO",
  "player.home.soon": "Coming soon",
  "player.home.streak": "ATTENDANCE STREAK",
  "player.home.streakSession": "{count} sessão consecutiva",
  "player.home.streakSessions": "{count} sessões consecutivas",
  "player.home.streakSub": "{count} consecutivas",
  "player.home.subtitle": "Todo listo para tu próximo treinamento.",
  "player.home.viewDetails": "Ver Detalles",
  "player.home.viewSchedule": "Ver Calendario Completo",
  "player.leaderboard.accumulatedXP": "{xp} XP acumulados",
  "player.leaderboard.challenges": "retos",
  "player.leaderboard.colMetric": "METRIC",
  "player.leaderboard.colPlayer": "TEAMMATE",
  "player.leaderboard.colRank": "RANK",
  "player.leaderboard.colXP": "XP TOTAL",
  "player.leaderboard.footerDesc": "O compromiso en os treinos e ou juego en time son ou camino para subir de rango en Mister11.",
  "player.leaderboard.footerTitle": "¡Cada sessão suma para ou time!",
  "player.leaderboard.leadingTeam": "👑 ¡Liderando a clasificación do time!",
  "player.leaderboard.matchesPlayedShort": "MP",
  "player.leaderboard.protectedData": "Datos de time protegidos",
  "player.leaderboard.subtitle": "Suma puntos XP com tu asistencia a treinos, minutos jugados e retos completados.",
  "player.leaderboard.tabAchievements": "Logros",
  "player.leaderboard.tabAttendance": "Presença",
  "player.leaderboard.tabGlobal": "Global XP",
  "player.leaderboard.tabMatches": "Jogos & Minutes",
  "player.leaderboard.tierTag": "Rango {tier}",
  "player.leaderboard.title": "TEAM PERFORMANCE LEADERBOARD",
  "player.leaderboard.xpDiff": "¡A solo {xp} XP do Top #{rank}!",
  "player.leaderboard.youChip": "YOU",
  "player.leaderboard.yourRank": "Your Position:",
  "player.leftFoot": "Canhoto",
  "player.linkedAccount": "Conta Vinculada",
  "player.matchHistory": "Jogo History",
  "player.matchHistoryEmpty": "No hay partidas registrados para este jogador.",
  "player.matches": "PARTIDAS",
  "player.matchesAbbr": "PJ",
  "player.minutes": "MINUTES",
  "player.minutesPlayed": "Minutes played",
  "player.nav.achievements": "Logros",
  "player.nav.chat": "Coach",
  "player.nav.home": "Início",
  "player.nav.profile": "Ficha",
  "player.nav.schedule": "Agenda",
  "player.nav.stats": "Stats",
  "player.nav.tests": "Testes",
  "player.noAccount": "Sem conta vinculada (edite o perfil para adicionar)",
  "player.noLinkedAccount": "Sem conta vinculada",
  "player.notifications.promptBtn": "ACTIVAR AVISOS",
  "player.notifications.promptDesc": "Recibe al instante as convocatorias oficiales do míster e recordatorios 2h antes de cada entreno.",
  "player.notifications.promptLater": "Later",
  "player.notifications.promptTitle": "¿Deseas activar avisos de convocatorias e partidas?",
  "player.openChat": "Abrir Chat com ou jogador",
  "player.plans.completeExercise": "Marcar como concluído",
  "player.plans.completedExercise": "Exercício completed!",
  "player.plans.error": "Error",
  "player.plans.noPlans": "Você não tem planos ativos atribuídos",
  "player.plans.posturalKey": "Clave Postural",
  "player.plans.prevention": "Injury Prevention",
  "player.plans.reps": "Repeticiones",
  "player.plans.rest": "Descanso",
  "player.plans.sets": "Series",
  "player.plans.stepByStep": "STEP-BY-STEP EXECUTION",
  "player.plans.subtitle": "Rutinas personalizadas asignadas por ou cuerpo técnico",
  "player.plans.title": "Individual Training Plans",
  "player.portal.activeCard": "Ficha activa:",
  "player.portal.family": "PORTAL FAMILIA",
  "player.portal.joinWithCode": "Entrar em um Time com Código",
  "player.portal.loading": "Cargando tu portal de jogador...",
  "player.portal.logoutAria": "Cerrar Sesión ou Cambiar Cuenta",
  "player.portal.myTeam": "Meu Time",
  "player.portal.notLinkedDesc": "Aún no estás vinculado a ningún time como jogador. Pídele ou código de acceso a tu entrenador ou pulsa a continuación para unirte a tu plantilla.",
  "player.portal.notLinkedTitle": "Olá, {name}!",
  "player.portal.parentView": "Parent View",
  "player.portal.player": "PLAYER PORTAL",
  "player.portal.selectTeamAria": "Seleccionar time de jogador",
  "player.portal.settingsAria": "Configurações & Preferences",
  "player.portal.switchToCoach": "Cambiar a Modo Entrenador",
  "player.portal.themeDarkAria": "Cambiar a modo oscuro",
  "player.portal.themeLightAria": "Cambiar a modo claro",
  "player.primaryPosition": "Posição Principal",
  "player.profile.account": "Access Account",
  "player.profile.account_deleted": "Tu conta ha sido eliminada correctamente.",
  "player.profile.activeCard": "Active Jogador:",
  "player.profile.age": "Edad",
  "player.profile.attendance": "ATTENDANCE",
  "player.profile.blockedUsers": "Usuarios Bloqueados",
  "player.profile.bmi": "BMI",
  "player.profile.bodyComp": "📊 Body Composition",
  "player.profile.bodyCompDesc": "Os parámetros antropométricos son supervisados periódicamente por ou cuerpo técnico para optimizar tu rendimiento e plan de preparación física.",
  "player.profile.category": "Category",
  "player.profile.consentClearSign": "Borrar firma",
  "player.profile.consentDrawLabel": "Firma do Padre / Tutor (com ou dedo ou ratón):",
  "player.profile.consentHealthCheck": "Datos de Salud e Molestias: Autorizo ou registro do check-in diario de bienestar e reporte de fatiga muscular com fines exclusivos de prevención de lesiones.",
  "player.profile.consentModalDesc": "Conforme al Reglamento General de Protección de Datos (RGPD) e a LOPDGDD, ou padre, madre ou tutor legal puede autorizar ou denegar os siguientes tratamientos de dados do menor:",
  "player.profile.consentModalTitle": "Consentimiento Parental Digital",
  "player.profile.consentParentNameLabel": "Nome e Sobrenome do Pai / Responsável *",
  "player.profile.consentPending": "Pending Signature",
  "player.profile.consentSaveSign": "Confirmar and Salvar Signature",
  "player.profile.consentSaving": "Salvando...",
  "player.profile.consentSigned": "Firmado e Válido",
  "player.profile.consentStatus": "Parental Consent Status",
  "player.profile.consentTestsCheck": "Tests e Rendimiento: Autorizo a realización de evaluaciones autónomas de velocidad, salto e resistencia para seguimiento técnico.",
  "player.profile.consent_error": "Error al salvar consentimiento.",
  "player.profile.consent_saved": "Consentimiento parental actualizado exitosamente.",
  "player.profile.deleteAccount": "Excluir Account & Data (GDPR)",
  "player.profile.deleteAccountDesc": "Esta acción es permanente e irreversible. Se excluirá tu acceso de usuario, tu historial deportivo, consentimientos e perfil en Mister11.",
  "player.profile.deleteAccountTitle": "Excluir your account?",
  "player.profile.deleteConfirmBtn": "Yes, Excluir Account",
  "player.profile.deleteConfirmPrompt": "Type DELETE to confirm:",
  "player.profile.deleteConfirmWord": "EXCLUIR",
  "player.profile.deleteDeleting": "Eliminando...",
  "player.profile.discomfortQuestion": "2. ¿Tienes alguna molestia ou dolor muscular?",
  "player.profile.discomfortZone": "Zona de desconforto:",
  "player.profile.dorsal": "DORSAL",
  "player.profile.foot": "Pie dominante",
  "player.profile.general": "GENERAL",
  "player.profile.goals": "Goals",
  "player.profile.hasDiscomfort": "🟡 Tengo molestias",
  "player.profile.health": "HEALTH",
  "player.profile.height": "Altura",
  "player.profile.logout": "Cerrar Sessão",
  "player.profile.matches": "Jogos",
  "player.profile.minutes": "Minutes",
  "player.profile.moodQuestion": "3. ¿Nivel de ánimo e energía hoy? (1 = Bajo, 5 = A tope)",
  "player.profile.noBlockedUsers": "You do not have any blocked users.",
  "player.profile.noDiscomfort": "🟢 Sin molestias",
  "player.profile.parentBadge": "Vista Familiar / Tutor",
  "player.profile.parent_name_required": "Escribe ou nome do padre/tutor.",
  "player.profile.physical": "PHYSICAL",
  "player.profile.plans": "PLANS",
  "player.profile.position": "Main Position",
  "player.profile.sendWellness": "Salvar Health Check-in",
  "player.profile.signConsent": "Firmar / Editar Consentimiento",
  "player.profile.sleepQuestion": "1. ¿Cómo dormiste e qué tal descansaste? (1 = Muy mal, 5 = Excelente)",
  "player.profile.switchToCoach": "Cambiar a Modo Entrenador",
  "player.profile.weight": "Peso",
  "player.profile.wellnessCheckin": "DAILY WELLNESS CHECK-IN",
  "player.profile.wellnessSent": "You have already submitted today's check-in! You can update it if your feelings change.",
  "player.profile.wellness_saved": "¡Check-in de bienestar salvo correctamente!",
  "player.profile.years": "years old",
  "player.rightFoot": "Destro",
  "player.schedule.attendance_error": "Error al salvar asistencia.",
  "player.schedule.backToCurrentMonth": "Voltar to current month",
  "player.schedule.calledBadge": "📋 Convocado",
  "player.schedule.calledUp": "Convocado",
  "player.schedule.calledUpDesc": "Você foi convocado pela comissão técnica. Dê 100% em campo!",
  "player.schedule.coachRating": "Nota do Treinador:",
  "player.schedule.emptyDesc": "Tu entrenador aún no ha programado sessões ou partidas en este mes.",
  "player.schedule.match": "MATCH",
  "player.schedule.minPlayed": "min jugados",
  "player.schedule.noEvents": "No events scheduled for this month.",
  "player.schedule.noMinutes": "Sem minutos",
  "player.schedule.notCalled": "Not called up for this match",
  "player.schedule.notCalledDesc": "Continue trabalhando firme nos treinos!",
  "player.schedule.pendingVerification": "Pending verification",
  "player.schedule.promptParent": "Will {name} attend this event?",
  "player.schedule.promptSelf": "¿Asistirás a esta sessão?",
  "player.schedule.reserve": "Standby / Reserve list",
  "player.schedule.reserveDesc": "Fique atento caso surja uma vaga de última hora.",
  "player.schedule.rsvpConfirmed": "Attendance confirmed: \"{status}\"",
  "player.schedule.rsvpGoing": "Going",
  "player.schedule.rsvpJustified": "Justificado",
  "player.schedule.rsvpLate": "Arriving late",
  "player.schedule.rsvpNotGoing": "Not going",
  "player.schedule.starter": "Titular",
  "player.schedule.substitute": "Reserva",
  "player.schedule.title": "Time Schedule",
  "player.schedule.training": "TRAINING",
  "player.settings.dangerZone": "Privacy Zone (GDPR)",
  "player.settings.deleteAccountDesc": "Elimina permanentemente tu usuario e desvincula tus dados personales.",
  "player.settings.installApp": "Install App (PWA)",
  "player.settings.installAppDesc": "Añade Mister11 a tu pantalla de inicio para acceso rápido sem descargas.",
  "player.settings.language": "Idioma do Aplicativo",
  "player.settings.modalTitle": "Configurações & Preferences",
  "player.settings.notifications": "Sessão Reminders",
  "player.settings.notificationsDesc": "Recibe notificações 1h antes de treinos e partidas.",
  "player.settings.sessionTitle": "Sessão & Account",
  "player.settings.switchModeTitle": "Rol e Permisos",
  "player.settings.theme": "Modo Oscuro",
  "player.shareConsent": "Compartilhar Consentimento dos Pais",
  "player.starter": "Titular",
  "player.stats.aboveAvg": "▲ +{xp} XP (Por encima de a media)",
  "player.stats.anonymousRgpd": "🔒 Anonymous data (GDPR)",
  "player.stats.areasInZero": "Áreas pendentes de medición",
  "player.stats.areasInZeroDesc": "O área Mental se activa completando cuestionarios en a pestaña Tests. As áreas Física, Técnica e Táctica se actualizan com as evaluaciones de tu entrenador.",
  "player.stats.assists": "ASISTENCIAS",
  "player.stats.average": "Média:",
  "player.stats.avgRating": "NOTA MEDIA",
  "player.stats.axis.attendance": "ATTENDANCE",
  "player.stats.axis.mental": "MENTAL",
  "player.stats.axis.physical": "PHYSICAL",
  "player.stats.axis.tactical": "TACTICAL",
  "player.stats.axis.technical": "TECHNICAL",
  "player.stats.belowAvg": "▼ +{xp} XP (Por debajo de a media)",
  "player.stats.cards": "CARDS",
  "player.stats.disciplinarySanctions": "Sanciones disciplinarias",
  "player.stats.evolutionTitle": "Test Evolution Over Time",
  "player.stats.friendlyMatch": "Amistoso",
  "player.stats.globalXpSubtitle": "Attendance + minutes + achievements",
  "player.stats.globalXpTitle": "XP Global",
  "player.stats.goToTests": "Ir a Cuestionarios",
  "player.stats.goals": "GOALS",
  "player.stats.hideGuide": "Hide guide",
  "player.stats.hideInfo": "Ocultar info",
  "player.stats.howAxesMeasured": "How is each axis measured?",
  "player.stats.howIsMeasured": "How is this measured?",
  "player.stats.howIsMeasuredDesc": "As asistencias e minutos se extraen de as actas oficiales do cuerpo técnico en estricto cumplimiento do RGPD.",
  "player.stats.inCompetition": "in competition",
  "player.stats.inMatch": "en {count} partida",
  "player.stats.inMatches": "en {count} partidas",
  "player.stats.keyPasses": "passes decisivos",
  "player.stats.leaderboardSubtitle": "Puntuación e compromiso en ou vestuario",
  "player.stats.leaderboardTitle": "Squad Leaderboard",
  "player.stats.makeTest": "Hacer test",
  "player.stats.matchHistory": "OFFICIAL MATCH HISTORY",
  "player.stats.matchHistorySync": "Sincronizado com actas do Míster",
  "player.stats.minutesPerMatch": "Minutos por partida",
  "player.stats.minutesPlayed": "MINUTES",
  "player.stats.noAttRecorded": "● Sin sessões registradas aún",
  "player.stats.noEvalsDesc": "Realiza os tests en a pestaña Tests ou espera a que tu entrenador registre tus mediciones para ver tus gráficas de progresión.",
  "player.stats.noEvalsYet": "No evaluations recorded yet",
  "player.stats.noMatchesDesc": "Tus minutos, goles e convocatorias aparecerán aquí automáticamente tras cada jornada.",
  "player.stats.noMatchesRecorded": "● Sin partidas disputados aún",
  "player.stats.noMatchesYet": "Sin partidas registrados aún esta temporada",
  "player.stats.noTeamDataDesc": "As métricas comparativas se activarán automáticamente quando ou míster registre asistencias ou partidas en a plantilla.",
  "player.stats.noTeamDataYet": "● Aún sem dados suficientes do time",
  "player.stats.officialMatch": "Oficial",
  "player.stats.officialMatches": "JOGOS",
  "player.stats.officialRating": "Nota Média Oficial",
  "player.stats.officialSummaryTitle": "OFFICIAL STATS 2026-27",
  "player.stats.onAvg": "● +{xp} XP (En a media)",
  "player.stats.pendingActaShort": "Pending match sheet",
  "player.stats.radarAtt": "Asistencia: Porcentaje real de asistencia a treinos e citaciones.",
  "player.stats.radarGuideTitle": "Fuente de informação de cada dimensión (0 a 100):",
  "player.stats.radarLevel": "Nivel Global: {level}",
  "player.stats.radarMental": "Mental: Cuestionarios psicológicos (ACSI-28, MTQ-10), treinamento cognitivo en juegos e valoración do cuerpo técnico.",
  "player.stats.radarPhys": "Físico: Tests de resistencia, velocidad e fuerza ou nota física asignada por ou cuerpo técnico.",
  "player.stats.radarTact": "Táctica: Posicionamiento, toma de decisiones e lectura de juego evaluados por ou míster.",
  "player.stats.radarTech": "Técnica: Control, pase, regate e finalización evaluados por ou entrenador.",
  "player.stats.radarTitle": "SKILLS RADAR",
  "player.stats.realTime": "⚡ In real time",
  "player.stats.seasonAverage": "Season average",
  "player.stats.sourceAttendance": "Asistencia: Proviene de os registros oficiales de asistencia que toma ou entrenador en cada sessão. Otorga +{xp} XP directos según tu porcentaje.",
  "player.stats.sourceAverage": "Media de a plantilla: Promedio agregado real do vestuario para comparar tu regularidad deportiva sem juicios negativos.",
  "player.stats.sourceInfoTitle": "¿De dónde provienen os dados e puntos XP de esta tabla?",
  "player.stats.sourceMatches": "Jogos / Minutes: Sourced from official match sheets and call-ups. Grants +{xp} XP proportional to your minutes played.",
  "player.stats.startsAndSubs": "{starts} tit. · {subs} sup.",
  "player.stats.title": "Stats & Performance",
  "player.stats.vsTeamTitle": "YOU VS TEAM AVERAGE",
  "player.stats.wellnessTitle": "Bienestar Semanal (Wellness)",
  "player.stats.xpByParticipation": "+{xp} XP based on your {pct}% participation",
  "player.stats.you": "Você",
  "player.substitute": "Reserva",
  "player.syncNotice": "Goals, lineups, and minutes recorded in the Jogos module will automatically synchronize here.",
  "player.tab.attendance": "PRESENÇA",
  "player.tab.chat": "CHAT",
  "player.tab.general": "GERAL",
  "player.tab.health": "SAÚDE",
  "player.tab.physical": "PHYSICAL",
  "player.tab.plans": "PLANOS",
  "player.tab.settings": "CONFIGURAÇÕES",
  "player.weight": "Peso",
  "playerDashboard.new_message": "💬 Nuevo mensaje do Míster:",
  "playerProfile.ageLabel": "Idade",
  "playerProfile.bmi": "BMI",
  "playerProfile.bmiDesc": "Estimated Body Mass Index.",
  "playerProfile.editTooltip": "Tap to edit your measurements",
  "playerProfile.heightLabel": "Altura",
  "playerProfile.heightRangeError": "A altura debe estar entre 100 e 230 cm.",
  "playerProfile.heightUnit": "cm",
  "playerProfile.physicalStats": "Dados Físicos",
  "playerProfile.readOnlyNotice": "A edad, dorsal e posición solo pueden ser modificados por ou cuerpo técnico.",
  "playerProfile.saveError": "Error al salvar os dados físicos.",
  "playerProfile.statsSaved": "Physical stats updated successfully.",
  "playerProfile.weightLabel": "Peso",
  "playerProfile.weightRangeError": "O peso debe estar entre 30 e 150 kg.",
  "playerProfile.weightUnit": "kg",
  "pos.all": "ALL",
  "pos.def": "DEF",
  "pos.del": "ST",
  "pos.ext": "W",
  "pos.ltd": "RB",
  "pos.lti": "LB",
  "pos.mc": "CM",
  "pos.mcd": "CDM",
  "pos.mco": "CAM",
  "pos.por": "GK",
  "pricing.badge.bestValueAcademies": "MELHOR CUSTO-BENEFÍCIO CLUBES",
  "pricing.badge.mostPopularCoach": "MAIS ESCOLHIDO TREINADORES",
  "pricing.billing.discountBadge": "2 MESES GRÁTIS",
  "pricing.billing.monthly": "Mensal",
  "pricing.billing.season": "Passe de Temporada (10 Meses)",
  "pricing.btn.selectClubPro": "SELECIONAR CLUB PRO",
  "pricing.btn.selectPremium": "SELECIONAR PREMIUM",
  "pricing.btn.selectStarter": "SELECIONAR STARTER",
  "pricing.btn.startFree": "COMEÇAR GRÁTIS",
  "pricing.btn.tryPro": "EXPERIMENTAR 7 DIAS GRÁTIS",
  "pricing.cancelAnytime": "Cancele quando quiser sem compromisso.",
  "pricing.clubPro.attr1_strong": "Até 15 Equipes",
  "pricing.clubPro.attr1_text": "Até 10 profissionais por equipe",
  "pricing.clubPro.attr2_strong": "Relatórios Consolidados de Clube",
  "pricing.clubPro.attr3_strong": "Histórico Global de Base e Suporte 24/7",
  "pricing.clubPro.vat": "~3,00 €/treinador/mês · IVA incluído",
  "pricing.coachPro": "Treinador PRO",
  "pricing.comparison.subtitle": "Analise cada recurso detalhadamente entre planos individuais e de clube com permissões verificadas.",
  "pricing.comparison.thModule": "Módulo e Recurso",
  "pricing.comparison.title": "Matriz Comparativa Detalhada de Recursos",
  "pricing.footer.install": "Instalar App / PWA",
  "pricing.footer.login": "Acesso Treinadores",
  "pricing.footer.rgpd": "LGPD e Privacidade",
  "pricing.footer.rights": "Todos os direitos reservados. Paleta Oficial Terra e Campo.",
  "pricing.footer.tagline": "A plataforma de inteligência técnica para o futebol de base e amador.",
  "pricing.free.attr1_strong": "1 Equipe",
  "pricing.free.attr1_text": "(23 atletas) · 1 Treinador",
  "pricing.free.attr2_strong": "10 Sessões",
  "pricing.free.attr2_text": "Prancheta básica · 5 IA/mês",
  "pricing.free.attr3_strong": "Assinatura Digital LGPD",
  "pricing.free.attr3_text": "incluída",
  "pricing.freq.forever": "/ para sempre",
  "pricing.freq.month": "/ mês",
  "pricing.freq.season": "/ temporada",
  "pricing.freq.seasonShort": "/ temp.",
  "pricing.fullAccess": "Acesso total a todos os recursos avançados.",
  "pricing.header.subtitle": "Preços com IVA incluído. O passe de temporada cobre os 10 meses de competição oficial com Julho e Agosto grátis.",
  "pricing.header.title": "Planos Transparentes para Treinadores e Clubes",
  "pricing.monthly": "Cobrança mensal",
  "pricing.plan.clubPremium.name": "Club Premium",
  "pricing.plan.clubPremium.tagline": "Para academias de alto rendimento e múltiplas sedes",
  "pricing.plan.clubPro.name": "Club PRO",
  "pricing.plan.clubPro.tagline": "Para clubes estruturados com metodologia própria",
  "pricing.plan.clubStarter.name": "Club Starter",
  "pricing.plan.clubStarter.tagline": "Para categorias de base e clubes em crescimento",
  "pricing.plan.free.name": "Plano Gratuito",
  "pricing.plan.free.tagline": "Para começar a digitalizar sua equipe",
  "pricing.plan.pro.name": "Plano PRO",
  "pricing.plan.pro.tagline": "Para o treinador que busca o máximo rendimento",
  "pricing.premium.attr1_strong": "Até 40 Equipes",
  "pricing.premium.attr1_text": "Comissão Técnica Ilimitada",
  "pricing.premium.attr2_strong": "Licenças Multi-Sede e Códigos",
  "pricing.premium.attr3_strong": "Onboarding Personalizado e Suporte VIP",
  "pricing.premium.vat": "IVA incluído · Suporte VIP",
  "pricing.pro.attr1_strong": "Até 3 Equipes",
  "pricing.pro.attr1_text": "Sessões ilimitadas e Live Stats",
  "pricing.pro.attr2_strong": "Súmula Oficial PDF 7 Páginas",
  "pricing.pro.attr2_text": "xG-Lite (105:68) e Métricas de Goleiro",
  "pricing.pro.attr3_strong": "Portal do Atleta",
  "pricing.pro.attr3_text": "Wellness diário, Testes e IA ilimitada",
  "pricing.pro.vatMonthly": "Cobrança mensal · Cancele quando quiser",
  "pricing.pro.vatSeason": "Equivale a 6,90 €/mês · IVA incluído",
  "pricing.starter.attr1_strong": "Até 6 Equipes",
  "pricing.starter.attr1_text": "Até 4 profissionais por equipe",
  "pricing.starter.attr2_strong": "Tudo o que está incluído no Plano PRO",
  "pricing.starter.attr3_strong": "Painel Multi-Treinador com Cargos",
  "pricing.starter.vat": "~5,50 €/treinador/mês · IVA incluído",
  "pricing.subscribeNow": "Assinar Agora",
  "pricing.vat.included": "IVA incluído",
  "push.foreground_toast": "🔔 Notificação {title}: {body}",
  "qrScanner.cameraPermissionError": "No se pudo acceder a a cámara. Revisa os permisos en tu navegador.",
  "qrScanner.hint": "Apunta a cámara al código QR proporcionado por ou entrenador para unirte automáticamente al time.",
  "qrScanner.noQrInImage": "No se detectó ningún código QR en a imagen seleccionada.",
  "qrScanner.title": "Scan Time QR Code",
  "qrScanner.unsupportedBrowser": "Tu navegador ou dispositivo no soporta a cámara.",
  "qrScanner.uploadQrPhoto": "Upload QR photo",
  "rendimientoPdf.btnDownload": "Baixar PDF",
  "rendimientoPdf.chartsTitle": "Jogador Metrics Comparison",
  "rendimientoPdf.generatedBy": "Generated by Mister11",
  "rendimientoPdf.matchDetails": "Detalhes da Partida",
  "rendimientoPdf.subtitle": "Estadísticas individuales por jogador e métricas canónicas",
  "rendimientoPdf.tableTitle": "Complete Performance Table",
  "rendimientoPdf.title": "INDIVIDUAL PERFORMANCE REPORT",
  "sector.activeZone": "Zona Activa: {zone}",
  "sesiones.actions.edit": "Editar",
  "sesiones.actions.share": "Compartir",
  "sesiones.blockCount.one": "{count} Bloque",
  "sesiones.blockCount.other": "{count} Bloques",
  "sesiones.categories.all": "Todas",
  "sesiones.categories.fisica": "Físico",
  "sesiones.categories.general": "General",
  "sesiones.categories.mixta": "Mixta",
  "sesiones.categories.partido": "Jogo",
  "sesiones.categories.tactica": "Tática",
  "sesiones.categories.tecnica": "Technical",
  "sesiones.clickDayToView": "Pulsa um día para ver sessões",
  "sesiones.exportICS": "📅 Exportar ICS",
  "sesiones.fieldMode": "Modo Campo",
  "sesiones.importSession": "Importar Sessão",
  "sesiones.newSession": "Criar Nova Sessão",
  "sesiones.noDiagram": "Sin diagrama",
  "sesiones.preview.addBlock": "+ Add Block",
  "sesiones.preview.blocks": "BLOCKS",
  "sesiones.preview.deleteAnimation": "EXCLUIR",
  "sesiones.preview.deleteSession": "Excluir Sessão",
  "sesiones.preview.editSession": "✏️ Editar Sessão",
  "sesiones.preview.emptyBlocks": "No hay bloques definidos.",
  "sesiones.preview.exportMp4": "🎬 EXPORTAR MP4",
  "sesiones.preview.exportPdf": "📄 Exportar to PDF",
  "sesiones.preview.generating": "⏳ Generando informe...",
  "sesiones.preview.googleCal": "📅 Google Cal",
  "sesiones.preview.ics": "📥 ICS",
  "sesiones.preview.load": "LOAD",
  "sesiones.preview.min": "MIN",
  "sesiones.preview.shareSession": "🔗 Share / Transfer Sessão",
  "sesiones.preview.startLiveField": "⏱️ Start Live Field Mode (Timer & Voice)",
  "sesiones.preview.structure": "Sessão Structure",
  "sesiones.preview.viewPdf": "Ver PDF",
  "sesiones.tab.animations": "Animaciones",
  "sesiones.tab.captures": "Capturas",
  "sesiones.tab.sessions": "Sessões",
  "sesiones.title": "Sessões de Treinamento",
  "sesiones.views.day": "DAY",
  "sesiones.views.month": "MONTH",
  "sesiones.views.week": "WEEK",
  "session.untitled": "Sem título",
  "sessionRating.averageRating": "Média",
  "sessionRating.commentPlaceholder": "Coaching notes or feedback (optional, max 200 chars)",
  "sessionRating.evolutionTitle": "Training Evolution",
  "sessionRating.noRatings": "Aún no hay calificaciones registradas para esta sessão.",
  "sessionRating.performanceTableSubtitle": "Últimas 5 sessões calificadas e media acumulada",
  "sessionRating.performanceTableTitle": "Desempenho nos Treinos",
  "sessionRating.radarAxisTraining": "Treino",
  "sessionRating.rateButton": "Calificar",
  "sessionRating.ratingLabel": "Nota",
  "sessionRating.saveError": "Error al salvar as calificaciones de a sessão.",
  "sessionRating.saveRatings": "Salvar Ratings",
  "sessionRating.savedSuccess": "Avaliação de treino registrada com sucesso.",
  "sessionRating.subtitle": "Evalúa ou rendimiento de os jogadores convocados (0 a 10)",
  "sessionRating.title": "Avaliação Pós-Treino (RPE)",
  "settings.teamIdentity": "Time Identity",
  "shot.badge_decisive": "DECISIVA",
  "shot.badge_normal": "NORMAL",
  "shot.blocked": "Finalização Bloqueada",
  "shot.cancel": "Cancelar",
  "shot.comfort": "Conforto da Finalização",
  "shot.comfort_comfortable": "Comfortable",
  "shot.comfort_pressed": "Presionado",
  "shot.comfort_very_pressed": "Muy Presionado",
  "shot.confirm": "Registrar Tiro",
  "shot.diff_decisive": "Decisiva",
  "shot.diff_normal": "Normal",
  "shot.difficulty": "Salvar Difficulty",
  "shot.goal": "Gol Marcado",
  "shot.missed": "Finalização para Fora",
  "shot.playType": "Play Type",
  "shot.playType_balon_parado": "Set Piece",
  "shot.playType_contra": "Contra",
  "shot.playType_jugada": "Jugada",
  "shot.playType_penalti": "Penalti",
  "shot.result": "Resultado da Finalização",
  "shot.result_bloqueado": "Bloqueado",
  "shot.result_fuera": "Fuera",
  "shot.result_gol": "Gol",
  "shot.result_parada": "Salvar",
  "shot.saved": "Finalização Defendida",
  "shot.step1": "1. Resultado",
  "shot.step2": "2. Dificultad",
  "shot.step3": "3. Comodidad",
  "shot.team": "Time",
  "shot.team_own": "Propio",
  "shot.team_rival": "Rival",
  "shot.title": "Mapa de Finalizações",
  "shot.zone": "Shot Zone",
  "shot.zone_inside_center": "Center (Box)",
  "shot.zone_inside_left": "Left Wing (Box)",
  "shot.zone_inside_right": "Right Wing (Box)",
  "shot.zone_outside_center": "Centro (Fuera)",
  "shot.zone_outside_left": "Banda Izq. (Fuera)",
  "shot.zone_outside_right": "Banda Der. (Fuera)",
  "shot.zone_penalty": "Penalty Spot",
  "spell.addToDictionary": "Add to dictionary",
  "spell.allCorrect": "No spelling issues",
  "spell.ignore": "Ignorar",
  "spell.missingAccent": "Falta tilde",
  "spell.noSuggestions": "Sin sugerencias directas",
  "spell.observations": "{count} spelling observation",
  "spell.observationsPlural": "{count} spelling observations",
  "spell.recommended": "Sugerencias:",
  "spell.title": "Spelling & Grammar",
  "spell.typo": "Typo",
  "spell.unrecognized": "Palabra no reconocida",
  "staff.cancelInvitation": "Cancelar invitation",
  "staff.changeRole": "Cambiar Rol:",
  "staff.copied": "Copiado!",
  "staff.copy": "Copiar",
  "staff.copyCode": "Copy Code",
  "staff.copyLink": "Copiar Enlace",
  "staff.copyLinkDesc": "Copia e envía este enlace al miembro do cuerpo técnico para que se uma al time:",
  "staff.createdDate": "Creada: {date}",
  "staff.generateLink": "⚡ Gerar Link / Código",
  "staff.inviteGenerated": "Convite Gerado!",
  "staff.inviteLinkCopied": "Link de convite copiado.",
  "staff.inviteModalDesc": "Introduce ou correo electrónico e selecciona ou rol. O usuario podrá acceder e colaborar en tiempo real.",
  "staff.inviteModalTitle": "Invite Coaching Staff Member",
  "staff.inviteStaffBtn": "Invitar Staff ({count}/{limit})",
  "staff.pendingInvitations": "Invitaciones Pendientes ({count})",
  "staff.realtimeSync": "Time: {team} · Real-time sync",
  "staff.remove": "Quitar",
  "staff.removeConfirm": "¿Estás seguro de excluir a {name} do cuerpo técnico?",
  "staff.role.admin": "Primer Entrenador (Admin)",
  "staff.role.analyst": "Tactical Analyst",
  "staff.role.assistant": "Ayudante / 3er Entrenador",
  "staff.role.assistantCoach": "Auxiliar Técnico",
  "staff.role.coach": "Auxiliar Técnico",
  "staff.role.collaborator": "Colaborador / Ayudante",
  "staff.role.coordinator": "Academy Director",
  "staff.role.delegate": "Time Delegate",
  "staff.role.doctor": "Time Doctor",
  "staff.role.fitness_coach": "Fitness Coach",
  "staff.role.goalkeeperCoach": "Goalkeeper Coach",
  "staff.role.headCoach": "Primer Entrenador",
  "staff.role.physicalTrainer": "Fitness Coach",
  "staff.role.physio": "Fisioterapeuta",
  "staff.role.player": "Jogador",
  "staff.role.scout": "Ojeador / Scout",
  "staff.roleAssistantCoach": "Auxiliar Técnico",
  "staff.roleDesc.admin": "Control total: gestión do time, miembros, partidas, sessões, salud e táctica.",
  "staff.roleDesc.analyst": "Registro e análisis de Live Stats en tiempo real, informes e analíticas.",
  "staff.roleDesc.assistant": "Registro de Live Stats, control de asistencia e apoyo en sessões.",
  "staff.roleDesc.coach": "Edición de partidas, alineaciones, sessões, pizarra, planning e asistencia.",
  "staff.roleDesc.fitness_coach": "Control de preparación física, cargas de treinamento, pruebas físicas e status atlético.",
  "staff.roleDesc.physio": "Acesso e edição de histórico médico, lesões, testes físicos/wellness e presença.",
  "staff.roleDesc.player": "Acesso somente leitura à sua ficha individual, sessões e calendário.",
  "staff.roleDoctor": "Médico",
  "staff.roleFitnessCoach": "Preparador Físico",
  "staff.roleGoalkeeperCoach": "Treinador de Goleiros",
  "staff.roleHeadCoach": "Treinador Principal",
  "staff.roleLabel": "Rol en ou Cuerpo Técnico",
  "staff.rolePhysio": "Fisioterapeuta",
  "staff.roleScout": "Olheiro / Analista",
  "staff.sendInvite": "Send Invitation",
  "staff.shareCodeDesc": "Comparte este código para que os jogadores ou sus padres se unan desde ou Portal (/join-team).",
  "staff.shareLink": "Compartir Enlace",
  "staff.shareNative": "📲 Compartir Enlace (WhatsApp / Apps)",
  "staff.sixDigitCode": "6-digit code:",
  "staff.staffTitle": "Cuerpo Técnico e Colaboradores",
  "staff.tab.active": "Comissão Ativa",
  "staff.tab.invites": "Convites",
  "staff.uniqueCodeTitle": "Unique Code for Jogadores & Families",
  "staff.you": "(You)",
  "staffHeredado.badgeActive": "PRO features active via {ownerName}'s plan",
  "staffHeredado.badgeActiveShort": "Plan Heredado ({ownerName})",
  "staffHeredado.gracePeriodBanner": "Aviso de suscripción: O plan do propietario ha cambiado. O time pasará a modo restringido en {days} días. Actualiza a PRO para mantener ou acceso ilimitado.",
  "staffHeredado.gracePeriodBlocked": "Acceso restringido: O periodo de gracia do time ha expirado. O propietario debe reactivar ou plan PRO para reanudar todas as funciones do staff.",
  "staffHeredado.restrictedFeatureStaff": "Esta función requiere que ou time cuente com um plan PRO ativo do propietario.",
  "staffHeredado.transferError": "Error al transferir a propiedad do time.",
  "staffHeredado.transferLimitExceeded": "Este usuario já tiene um time en su plan gratuito. Debe atualizar a PRO para poder aceptar a propiedad de este time.",
  "staffHeredado.transferSuccess": "Time ownership transferred successfully to {userName}.",
  "staffInvite.cardSubtitle": "Código exclusivo para vincular colaboradores, preparadores e analistas al cuerpo técnico.",
  "staffInvite.cardTitle": "ACCESS CODE FOR COACHES / STAFF",
  "staffInvite.codeCopied": "Staff code copied",
  "staffInvite.copyCode": "Copy Code",
  "staffInvite.copyLink": "Copiar Enlace",
  "staffInvite.downloadQr": "Baixar QR Image",
  "staffInvite.emailLabel": "Correo electrónico do colaborador:",
  "staffInvite.inputPlaceholder": "Ej. ABC123 ou STF-ABC123",
  "staffInvite.inviteEmail": "Invite via Email",
  "staffInvite.joinBtn": "JOIN TEAM",
  "staffInvite.joinSubtitle": "Si has sido invitado por ou míster principal, ingresa tu código aquí.",
  "staffInvite.joinTitle": "ACCESS CODE FOR COACHES / STAFF",
  "staffInvite.linkCopied": "Staff link copied",
  "staffInvite.messageLabel": "Invitation message:",
  "staffInvite.modalTitle": "Invitar Miembro do Cuerpo Técnico",
  "staffInvite.qrCopied": "Enlace copiado",
  "staffInvite.qrModal": "View Staff QR",
  "staffInvite.qrModalTitle": "Staff QR Invitation Code",
  "staffInvite.qrSubtitle": "O entrenador invitado puede escanear este código com su móvil para unirse al cuerpo técnico:",
  "staffInvite.roleLabel": "Rol asignado:",
  "staffInvite.sendBtn": "Send Invitation",
  "staffInvite.sendSuccess": "Invitación enviada com éxito.",
  "staffInvite.shareLink": "Compartir Enlace",
  "staffJoin.assignedRole": "Rol Asignado:",
  "staffJoin.btnSubmit": "Buscar and Join",
  "staffJoin.confirmJoin": "CONFIRM AND JOIN STAFF",
  "staffJoin.errors.invalidCode": "Código de staff no válido ou expirado. Contacta al míster.",
  "staffJoin.inputPlaceholder": "Ej. STF-ABC123 ou ABC123",
  "staffJoin.linkPlaceholder": "https://mister11.com/join-staff?code=ABC123",
  "staffJoin.orPasteLink": "¿Tienes um enlace de invitación? Pégalo aquí:",
  "staffJoin.searching": "Validating code in real time...",
  "staffJoin.subtitle": "Ingresa ou código de 6 caracteres proporcionado por ou entrenador principal ou pega ou enlace de invitación.",
  "staffJoin.success": "¡Te has unido com éxito al Cuerpo Técnico!",
  "staffJoin.teamFound": "Time Found:",
  "staffJoin.title": "Join Technical Staff",
  "stats.eventMap.guide": "Distribución territorial de as intervenciones do time (recuperaciones, duelos, tiros e faltas). Indica dónde está trabajando, ganando disputas ou sufriendo ou time en ou terreno de juego.",
  "stats.eventMap.pass_insufficient": "Red de pases no disponible: Se requieren al menos 5 pases registrados para generar a red táctica. Se muestra ou mapa de intervenciones por zona.",
  "stats.eventMap.title": "Zone Event Map",
  "stats.passNetwork.guide": "Cada nodo representa a posición media do jogador e ou grosor de as líneas indica ou volumen de pases entre compañeros. Permite identificar as sociedades clave e a fluidez asociativa en a salida de balón.",
  "stats.theater.close": "Fechar theater mode",
  "stats.theater.exit_fullscreen": "Exit Fullscreen",
  "stats.theater.fullscreen": "Pantalla Completa",
  "stats.theater.theater_mode": "Modo Teatro",
  "status.none": "Sin Seleccionar",
  "swot.add_manual": "Add manual observation",
  "swot.ai_summary_title": "Tactical Summary (AI)",
  "swot.auto_badge": "Regla",
  "swot.btn_generate_ai": "Redactar resumen com IA",
  "swot.generating_ai": "Redactando com IA...",
  "swot.manual_badge": "Manual",
  "swot.no_items": "No observations recorded for this quadrant.",
  "swot.opportunities": "Oportunidades Táticas",
  "swot.origin_metric": "Origin metric",
  "swot.rule.central_box_leak": "Vulnerabilidad en ou pasillo central dentro do área propia.",
  "swot.rule.counter_efficiency": "Peligro constante e transiciones rápidas al contragolpe.",
  "swot.rule.duels_fragility": "Baja tasa de éxito en disputas divididas comprometiendo a posesión.",
  "swot.rule.duels_superiority": "Dominio territorial e contundencia en os duelos individuales.",
  "swot.rule.gk_decisive_hero": "Portería determinante com intervenciones decisivas de alto mérito.",
  "swot.rule.gk_high_exertion": "Alta exigencia sobre ou guardameta debido a llegadas rivales frecuentes.",
  "swot.rule.high_attendance_cohesion": "Excelente constancia de presencia de plantilla e sincronización do bloque.",
  "swot.rule.high_xg_diff": "High attacking creation volume outperforming opponent in clear chances.",
  "swot.rule.late_fatigue": "Goles ou remates encajados en os últimos 15 minutos reflejan fatiga.",
  "swot.rule.low_xg_conv": "Ocasiones generadas com baja conversión a gol, requiriendo afinar a definición.",
  "swot.rule.rival_high_comfort": "O rival remata com excesiva comodidad sem oposición defensiva cercana.",
  "swot.rule.set_piece_threat": "Chances conceded on set pieces require tighter defensive marking.",
  "swot.rule.wing_defense_solid": "Control efectivo de os pasillos laterales reduciendo peligro rival.",
  "swot.strengths": "Pontos Fortes (Forças)",
  "swot.threats": "Ameaças do Adversário",
  "swot.title": "Matriz DAFO Trazable",
  "swot.weaknesses": "Pontos Fracos (Fraquezas)",
  "team.squadCount.one": "{count} jogador no elenco",
  "team.squadCount.other": "{count} jogadores no elenco",
  "team.title": "My Time",
  "teamMembers.admin_only_remove": "Solo ou Primer Entrenador (Admin) puede excluir miembros do time.",
  "teamMembers.already_member": "Este usuario já es miembro do cuerpo técnico.",
  "teamMembers.invite_cancelled": "Invitation cancelled.",
  "teamMembers.invite_generated": "Enlace e código de invitación generados com éxito.",
  "teamMembers.member_removed": "Miembro excluído do cuerpo técnico.",
  "teamMembers.role_updated": "Rol actualizado a {role}.",
  "teamQr.codeCopiedToast": "Time code copied to clipboard",
  "teamQr.copied": "Copiado",
  "teamQr.copyCode": "Copy Code",
  "teamQr.downloadImage": "Baixar QR Image",
  "teamQr.linkCopiedToast": "Invitation link copied to clipboard",
  "teamQr.modalTitle": "Time QR Code and Access Link",
  "teamQr.scanInstructions": "Muestra este código QR a os jogadores ou comparte ou enlace directo para que se unan al time:",
  "teamQr.shareLink": "Compartir Enlace",
  "teamQr.teamCodeLabel": "Access Code:",
  "test.answeringAll": "Por favor responde todas as preguntas do test.",
  "test.auto.acsi28.cat": "Afrontamiento e Presión",
  "test.auto.acsi28.desc": "Evalúa tu capacidad para mantener a calma ante errores, soportar a presión do rival e concentrarte en momentos clave.",
  "test.auto.acsi28.name": "ACSI-28 (Afrontamiento Deportivo)",
  "test.auto.acsi28.q1": "Mantengo a calma e uma actitud positiva aunque ou time vaya perdiendo.",
  "test.auto.acsi28.q2": "Si cometo um erro ou pierdo um balón, lo olvido rápido e me concentro en a siguiente jugada.",
  "test.auto.acsi28.q3": "Me mantengo concentrado en ou partida a pesar de os gritos ou distracciones externas.",
  "test.auto.acsi28.q4": "Puedo enfocarme al 100% en a tarea táctica que me pide ou míster.",
  "test.auto.acsi28.q5": "Siento total segurança en mis habilidades antes de saltar al campo.",
  "test.auto.acsi28.q6": "En os minutos finales ou momentos decisivos juego com a misma soltura sem atenazarme.",
  "test.auto.acsi28.q7": "Acepto as correcciones do entrenador entendiendo que son para hacerme mejor jogador.",
  "test.auto.acsi28.q8": "Me adapto rápidamente si ou míster me cambia de posición ou rol durante ou partida.",
  "test.auto.acsi28.short": "ACSI-28",
  "test.auto.geq.cat": "Time Spirit and Dressing Room",
  "test.auto.geq.desc": "Evalúa a unión do grupo, a comunicación entre compañeros e ou sentido de pertenencia en ou time.",
  "test.auto.geq.name": "GEQ (Cohesión de Equipo e Clima)",
  "test.auto.geq.q1": "Todos en ou vestuario remamos en a misma dirección para alcanzar os objetivos.",
  "test.auto.geq.q2": "Nos apoyamos e animamos mutuamente quando alguien comete um fallo.",
  "test.auto.geq.q3": "Existe um ambiente sano, divertido e de compañerismo fuera do campo.",
  "test.auto.geq.q4": "Me siento 100% valorado e integrado en este time.",
  "test.auto.geq.short": "GEQ Cohesion",
  "test.auto.goals.cat": "Metas y Enfoque",
  "test.auto.goals.desc": "Evalúa cómo planificas tus objetivos técnicos e físicos para superarte semana a semana.",
  "test.auto.goals.name": "Goal Setting Scale",
  "test.auto.goals.q1": "Tengo claro qué aspectos técnicos ou físicos debo mejorar este mes.",
  "test.auto.goals.q2": "Me esfuerzo extra en os ejercicios que me resultan mais difíciles.",
  "test.auto.goals.q3": "Reviso mis partidas e entrenos para ver qué puedo hacer mejor a próxima vez.",
  "test.auto.goals.short": "Metas Individuales",
  "test.auto.mhc.cat": "Bienestar Psicodeportivo",
  "test.auto.mhc.desc": "Mide tu disfrute por ou fútbol, satisfacción personal e sensación de progreso como deportista.",
  "test.auto.mhc.name": "MHC-SF (Bienestar Emocional)",
  "test.auto.mhc.q1": "Disfruto e me siento feliz cada vez que voy a entrenar ou jugar.",
  "test.auto.mhc.q2": "Siento que ou fútbol me ajuda a ser mejor persona e desarrollar disciplina.",
  "test.auto.mhc.q3": "Tengo uma relación de confianza e respeto com ou cuerpo técnico.",
  "test.auto.mhc.short": "Bienestar Mental",
  "test.auto.mtq10.cat": "Fortaleza Mental",
  "test.auto.mtq10.desc": "Mide tu determinación, perseverancia e cómo transformas os momentos difíciles en oportunidades de crecimiento.",
  "test.auto.mtq10.name": "MTQ-10 (Fortaleza e Resiliencia)",
  "test.auto.mtq10.q1": "Mantengo ou control emocional quando ou árbitro ou uma jugada no sale como esperaba.",
  "test.auto.mtq10.q2": "Cumplo com os treinos e ou plan físico incluso os días que no tengo motivación.",
  "test.auto.mtq10.q3": "Veo os rivales difíciles e os desafíos como uma oportunidad para demostrar mi nivel.",
  "test.auto.mtq10.q4": "Confíou en mi capacidad para superar cualquier bache de juego ou suplencia.",
  "test.auto.mtq10.q5": "No me rindo jamás hasta que ou árbitro pita ou final do encuentro.",
  "test.auto.mtq10.short": "Fortaleza MTQ",
  "test.auto.rpe.cat": "Carga e Esfuerzo Físico",
  "test.auto.rpe.desc": "Registra a intensidad do esfuerzo percibido tras tu último treinamento ou partida en a escala validada Borg 1-10.",
  "test.auto.rpe.name": "RPE (Escala Borg CR-10)",
  "test.auto.rpe.q1": "¿Qué nivel de intensidad ou esfuerzo físico sentiste en tu última sessão ou partida?",
  "test.auto.rpe.short": "RPE Esfuerzo",
  "test.backToCatalog": "Voltar to test catalog",
  "test.category.aerobic": "Aeróbico e Resistência",
  "test.category.anaerobic": "Potência Anaeróbica",
  "test.category.flexibility": "Flexibilidade",
  "test.category.speed": "Velocidade e Sprint",
  "test.category.strength": "Força e Potência",
  "test.completedBadge": "Completado",
  "test.completedSuccess": "Teste {name} concluído com sucesso! ({pct}%)",
  "test.dim.belonging": "Pertenencia",
  "test.dim.challenge": "Challenge",
  "test.dim.coachability": "Entrenabilidad",
  "test.dim.commitment": "Compromiso",
  "test.dim.concentration": "Concentration",
  "test.dim.confidence": "Confianza",
  "test.dim.coping": "Afrontamiento",
  "test.dim.emotionalControl": "Control Emocional",
  "test.dim.goalClarity": "Goal Clarity",
  "test.dim.groupSupport": "Apoyo Grupal",
  "test.dim.perceivedEffort": "Esfuerzo Percibido",
  "test.dim.perseverance": "Perseverancia",
  "test.dim.purpose": "Purpose",
  "test.dim.selfAnalysis": "Self-Analysis",
  "test.dim.selfOvercoming": "Self-Improvement",
  "test.dim.socialCohesion": "Social Cohesion",
  "test.dim.sportsJoy": "Disfrute Deportivo",
  "test.dim.staffTrust": "Confianza Staff",
  "test.dim.taskCohesion": "Task Cohesion",
  "test.dim.underPressure": "Peak Performance under Pressure",
  "test.dimension": "Dimension",
  "test.errorSaving": "Error al salvar ou test. Inténtalo de nuevo.",
  "test.finishAndSend": "FINALIZAR E ENVIAR AO TREINADOR",
  "test.initialEvaluationRegistered": "Initial evaluation recorded",
  "test.lastResult": "Last result",
  "test.of": "de",
  "test.opt.agree": "Agree",
  "test.opt.almostAlways": "Casi siempre",
  "test.opt.almostNever": "Casi nunca",
  "test.opt.always": "Siempre",
  "test.opt.disagree": "Disagree",
  "test.opt.little": "Slightly agree",
  "test.opt.mostTimes": "A mayoría de veces",
  "test.opt.never": "Nunca",
  "test.opt.notAtAll": "Not at all agree",
  "test.opt.often": "A menudo",
  "test.opt.quite": "Moderately agree",
  "test.opt.quiteAgree": "Moderately agree",
  "test.opt.rarely": "Raras veces",
  "test.opt.rpe1": "1 - Very light (recovery)",
  "test.opt.rpe10": "10 - Maximum effort (absolute peak)",
  "test.opt.rpe2": "2 - Light (comfortable)",
  "test.opt.rpe3": "3 - Moderate (steady aerobic)",
  "test.opt.rpe4": "4 - Algo duro (se siente ou cansancio)",
  "test.opt.rpe5": "5 - Duro (esfuerzo notable)",
  "test.opt.rpe6": "6 - Bastante duro",
  "test.opt.rpe7": "7 - Muy duro (alta intensidad)",
  "test.opt.rpe8": "8 - Muito difícil + (perto do limite)",
  "test.opt.rpe9": "9 - Extenuante",
  "test.opt.sometimes": "A veces",
  "test.opt.somewhatDisagree": "Slightly agree",
  "test.opt.stronglyAgree": "Strongly agree",
  "test.opt.stronglyDisagree": "Strongly disagree",
  "test.previous": "Anterior",
  "test.question": "Pregunta",
  "test.questionProgress": "Question {current} of {total}",
  "test.questionsCount": "{count} preguntas",
  "test.repeatTest": "Repetir Test",
  "test.retakeTest": "Repetir Cuestionario",
  "test.saveAnswers": "Salvar & Finish",
  "test.saving": "Salvando...",
  "test.startTest": "Iniciar Cuestionario",
  "test.successSaved": "Test concluído e registrado en tu expediente.",
  "test.tabSubtitle": "Completa estos cuestionarios desde tu móvil para potenciar tu mentalidad, concentración e cohesión com ou time.",
  "test.tabTitle": "Tests & Autoevaluaciones",
  "test.timeEstimate": "{minutes} min aprox.",
  "tests.alertResetConfirm": "Tem certeza de que deseja redefinir os dados da temporada?",
  "tests.attention": "⚠️ ATTENTION",
  "tests.catalogPhysical": "Catálogo de Testes: FÍSICOS",
  "tests.catalogPsychosocial": "Catálogo de Testes: PSICOSSOCIAIS",
  "tests.confirm_delete": "Confirmar deletion",
  "tests.confirm_season_reset": "Reset Season",
  "tests.createTest": "+ Criar Teste",
  "tests.demoData": "🎯 Dados de Demonstração",
  "tests.demoDataTooltip": "Insere avaliações fictícias para pré-visualizar os gráficos",
  "tests.demoSuccess": "Dados de demonstração carregados com sucesso!",
  "tests.error": "Error",
  "tests.exportReport": "Exportar Relatório",
  "tests.insert_demo": "Insertar dados demo",
  "tests.matrix.exportTeamReport": "Exportar Relatório Coletivo",
  "tests.matrix.initialEval": "Aval Inicial",
  "tests.matrix.latestEval": "Última Aval",
  "tests.matrix.number": "Número",
  "tests.matrix.player": "Jogador",
  "tests.matrix.previousEval": "Penúltima Aval",
  "tests.matrix.progress": "Evolução",
  "tests.matrix.title": "MATRIZ DE PLANEJAMENTO",
  "tests.metricUnit": "Medida: ",
  "tests.modal.cancel": "CANCELAR",
  "tests.modal.confirm": "ACEITAR",
  "tests.modal.downloadTemplate": "Baixar Modelo de Coleta de Dados",
  "tests.modal.execution": "Execução:",
  "tests.modal.executionProtocol": "PROTOCOLO DE EXECUÇÃO",
  "tests.modal.goToRecord": "Ir para Registrar Resultados",
  "tests.modal.measurement": "Medição:",
  "tests.modal.noProtocol": "Nenhum protocolo detalhado especificado para este teste.",
  "tests.modal.objective": "Objetivo:",
  "tests.modal.objectiveDesc": "OBJETIVO E DESCRIÇÃO",
  "tests.modal.recordTitle": "Registro:",
  "tests.modal.rfefBadge": "Barema Oficial RFEF (Percentis Masculino e Feminino)",
  "tests.modal.rfefTooltip": "Fonte: Real Federación Española de Fútbol (RFEF) - Padrões de Aptidão Física no Futebol Formativo Feminino (Salto Horizontal Pés Juntos).",
  "tests.modal.unit": "Unidade de medida:",
  "tests.modal.unitLabel": "Unidade: ",
  "tests.newModal.category": "Categoria Específica",
  "tests.newModal.categoryPlaceholder": "Ex. Resistência, Psicologia...",
  "tests.newModal.desc": "Descrição Rápida",
  "tests.newModal.descPlaceholder": "Resumo do teste",
  "tests.newModal.name": "Nome do Teste",
  "tests.newModal.namePlaceholder": "Ex. 1RM Agachamento",
  "tests.newModal.physical": "Físico",
  "tests.newModal.protocol": "Protocolo de Execução Completo",
  "tests.newModal.protocolPlaceholder": "Passos exatos de como o teste é realizado em campo...",
  "tests.newModal.psychosocial": "Psicossocial",
  "tests.newModal.socioemotional": "Socioemocional",
  "tests.newModal.tactical": "Tático",
  "tests.newModal.title": "Novo Teste",
  "tests.newModal.type": "Tipo de Teste",
  "tests.newModal.unit": "Unidade de Medida",
  "tests.newModal.unitPlaceholder": "Ex. kg, seg, pts",
  "tests.record": "REGISTRAR",
  "tests.resetSeason": "🗑️ Reiniciar Temporada",
  "tests.resetSeasonTooltip": "Exclui todos os dados de avaliação dos jogadores para iniciar uma nova temporada",
  "tests.resources.drillDatabase": "Exercícios",
  "tests.resources.myTeam": "Mi Plantilla",
  "tests.resources.seasonReport": "Season Report",
  "tests.resources.tacticalLibrary": "Quadro Tático",
  "tests.resources.tacticalTest": "Tactical Test",
  "tests.resources.teamChat": "Time Chat",
  "tests.resources.title": "Recursos e Ferramentas",
  "tests.rpe.cancel": "CANCEL",
  "tests.rpe.save": "SAVE RPE",
  "tests.saveResults": "Salvar Results",
  "tests.success": "Success",
  "tests.tab.comparativa": "Comparativo",
  "tests.tab.fisicos": "Testes Físicos",
  "tests.tab.historial": "Histórico",
  "tests.tab.prevencion": "Prevenção e Saúde",
  "tests.tab.psicosociales": "Psicossociais",
  "tests.template": "MODELO",
  "tests.title": "AVALIAÇÃO E TESTES",
  "tests.validation": "Validation",
  "tests.wellness.save": "Salvar Evaluation",
  "wellness.fatigue": "Nível de Fadiga",
  "wellness.mood": "Humor / Disposição",
  "wellness.rpe.cancel": "CANCEL",
  "wellness.rpe.desc": "Registra cómo percibió ou esfuerzo {name}.",
  "wellness.rpe.durationLabel": "Sessão duration (minutes)",
  "wellness.rpe.levelLabel": "Exertion Level (RPE 1-10)",
  "wellness.rpe.save": "SAVE RPE",
  "wellness.rpe.scaleMax": "10 - Maximum effort",
  "wellness.rpe.scaleMin": "1 - Muy suave",
  "wellness.rpe.title": "Rate of Perceived Exertion (RPE)",
  "wellness.rpe.trainingLoad": "Training Load (RPE × Duration):",
  "wellness.sleep": "Qualidade do Sono",
  "wellness.soreness": "Dor Muscular",
  "wellness.stress": "Nível de Estresse",
  "whiteboard.exportError": "Error al exportar ou video MP4. Inténtalo de nuevo.",
  "whiteboard.exportRetry": "Retry export",
  "whiteboard.exportSuccess": "Video MP4 exportado com éxito.",
  "whiteboard.exportingFrame": "Exporting frame {current} of {total}...",
  "xg.box_center": "Central Box",
  "xg.box_wings": "Lateral Box",
  "xg.decisive_pct": "% Decisivas Exitosas",
  "xg.decisive_saves": "Paradas Decisivas",
  "xg.demanding_match": "Demanding Jogo",
  "xg.desc": "Probabilidad estadística de gol basada en zona, comodidad e tipo de jugada.",
  "xg.exposure_map": "Defensive Exposure Map",
  "xg.gk_exertion": "GK Exertion Index",
  "xg.label": "Expected Goals (xG)",
  "xg.normal_match": "Exigencia Controlada",
  "xg.normal_saves": "Paradas Normales",
  "xg.outside_box": "Fora da Área",
  "xg.own_xg": "xG Propio",
  "xg.penalty_box": "Penalti",
  "xg.rival_comfort": "Comodidad Rival",
  "xg.rival_xg": "xG Rival",
  "xg.save_pct": "Salvar Effectiveness %",
  "xg.title": "xG-Lite Model & Exposure",
  "xg.totalTeam": "xG Total do Time",
  "xg.total_saves": "Total Paradas",
  "clinical.fallbackChip": "conteúdo clínico em espanhol",
  "landing.footer.languages": "Idiomas",
  "landing.footer.rights": "Todos os direitos reservados.",
  "landing.hero.badge": "O CÉREBRO DIGITAL DO TREINADOR",
  "landing.hero.btnPrimary": "EXPERIMENTAR 7 DIAS GRÁTIS",
  "landing.hero.btnSecondary": "VER PLANOS E TARIFAS",
  "landing.hero.desc": "Prancheta tática interativa, registro ao vivo com proporção regulamentar FIFA 105:68, prevenção de lesões com IA, testes psicométricos validados e relatórios oficiais em PDF.",
  "landing.hero.title_highlight": "nível profissional",
  "landing.hero.title_part1": "Leve a sua metodologia de treino ao",
  "landing.nav.login": "INICIAR SESSÃO",
  "landing.nav.selectLang": "Selecionar idioma",
  "landing.nav.themeToggle": "Alternar tema",
  "landing.preview.title": "Prancheta Tática Mister11 · Campo e Peças",
  "landing.trust.noCard": "Sem cartão de crédito",
  "landing.trust.platforms": "Web, PWA e Android",
  "landing.trust.trial": "7 dias de teste total",
  "pricing.toggle.monthly": "Mensal",
  "pricing.toggle.season": "Passe de Temporada (Recomendado)",
  "pdf.trainingSheet": "FICHA DE TREINO",
  "pdf.date": "DATA",
  "pdf.time": "HORA",
  "pdf.duration": "DURAÇÃO",
  "pdf.intensity": "INTENSIDADE",
  "pdf.category": "CATEGORIA",
  "pdf.material": "MATERIAL",
  "pdf.blocks": "BLOCOS",
  "pdf.mainTacticalDiagram": "DIAGRAMA TÁTICO PRINCIPAL",
  "pdf.trainingBlocks": "BLOCOS DE TREINAMENTO",
  "pdf.convocation": "CONVOCAÇÃO",
  "pdf.postSessionNotes": "NOTAS PÓS-SESSÃO",
  "pdf.notesEmpty": "Sem notas registradas",
  "pdf.myTeam": "Meu Time",
  "pdf.footerBrand": "Mister11 Platform - mister11.app",
  "pdf.pageOf": "Pagina {cur} de {total}",
  "pdf.objectivePrefix": "Objetivo: ",
  "player.greet.hello": "Olá!",
  "player.join": "Entrar com Código",
  "player.ach.unlocked": "DESBLOQUEADOS",
  "player.tier.bronze": "Bronze",
  "player.tier.silver": "Prata",
  "player.tier.gold": "Ouro",
  "player.period.biweekly": "Esta quinzena",
  "player.profile.dominantFoot": "Pé dominante: {foot}",
  "player.profile.rightFoot": "Destro",
  "player.profile.leftFoot": "Canhoto",
  "player.profile.ambidextrous": "Ambidestro",
  "player.consent.signEdit": "Assinar / Editar Consentimento",
  "player.auth.switchToCoach": "Mudar para Modo Treinador",
  "player.auth.logout": "Encerrar Sessão",
  "player.auth.deleteAccount": "Excluir Conta e Dados (LGPD/GDPR)",
  "player.games.healthyTraining": "TREINAMENTO SAUDÁVEL",
  "player.games.homeChallenges": "Desafios em Casa",
  "player.games.reactionSpeed": "VELOCIDADE DE REAÇÃO",
  "player.games.workingMemory": "MEMÓRIA DE TRABALHO",
  "player.games.tacticalReading": "LEITURA TÁTICA",
  "player.games.play": "JOGAR",
  "player.wellness.dailyCheckin": "CHECK-IN DIÁRIO DE BEM-ESTAR",
  "player.wellness.saveCheckin": "ENVIAR CHECK-IN DIÁRIO",
  "player.wellness.updateCheckin": "ATUALIZAR ESTADO GERAL",
  "player.wellness.medicalHistory": "Histórico Médico e Lesões",
  "player.wellness.recordInjury": "REGISTRAR DESCONFORTO OU LESÃO",
  "player.plans.individualPlans": "Planos de Treinamento Individual",
  "player.plans.evolutionConstancy": "EVOLUÇÃO E CONSTÂNCIA",
  "player.plans.activeCount": "{count} Planos Ativos",
  "player.plans.allUpToDate": "Tudo em dia com seus planos!",
  "player.ach.tabs.vitrina": "Vitrine",
  "player.ach.tabs.games": "Jogos e Desafios",
  "player.ach.tabs.ranking": "Ranking",
  "player.schedule.prevMonth": "Mês anterior",
  "player.schedule.nextMonth": "Mês seguinte",
  "player.schedule.calledUpTitle": "Convocado para a partida!",
  "player.schedule.reserveTitle": "Lista de espera / Reserva",
  "player.schedule.notCalledTitle": "Não convocado para esta rodada",
  "player.schedule.played": "jogados",
  "player.schedule.sheetClosed": "Súmula oficial fechada",
  "player.schedule.officialMinutes": "Minutos oficiais: {min}'",
  "player.schedule.dnp": "Não jogou nesta partida",
  "player.schedule.parentPrompt": "{name} comparecerá a este evento?",
  "player.schedule.playerPrompt": "Você comparecerá a esta sessão?",
  "player.schedule.officialRecorded": "Presença oficial registrada pela comissão técnica",
  "player.schedule.pendingVerificationDesc": "Sessão realizada, pendente de verificação da comissão técnica",
  "player.schedule.parentTrainingPrompt": "{name} comparecerá a este treino?",
  "player.schedule.playerTrainingPrompt": "Você comparecerá a este treino?",
  "player.schedule.photosCaptures": "Fotos e Registros do Evento",
  "player.schedule.noEventsDesc": "Seu treinador ainda não agendou sessões ou partidas para este mês.",
  "player.plans.active": "Ativo",
  "player.plans.progressionHabit": "EVOLUÇÃO E HÁBITO",
  "player.plans.activePlan": "Plano Ativo",
  "player.plans.activePlans": "Planos Ativos",
  "player.plans.youth": "Base / Juvenil",
  "player.plans.monitoring": "Acompanhamento",
  "player.plans.loading": "Carregando seus planos de treinamento...",
  "player.plans.upToDate": "Tudo em dia com a sua preparação!",
  "player.plans.techRoutine": "Rotina Técnica e Preventiva",
  "player.plans.defaultPlanTitle": "Plano de Desenvolvimento Individual",
  "player.plans.coachInstructions": "Instruções do Treinador:",
  "player.plans.todayExercises": "Exercícios para Hoje:",
  "player.plans.doneCount": "concluídos",
  "player.plans.markPending": "Marcar como pendente",
  "player.plans.viewGuide": "Ver guia de execução técnica",
  "player.plans.guide": "Guia",
  "player.plans.notAgeSafe": "Não recomendado para sua idade",
  "player.plans.ageSafeTooltip": "Este exercício requer idade mínima de {minAge} anos por segurança biomecânica.",
  "player.stats.evaluation": "Avaliação",
  "player.stats.general": "Geral",
  "player.stats.session": "Sessão",
  "player.stats.starter": "Titular",
  "player.stats.sub": "Reserva",
  "player.stats.pendingSheet": "Pendente de súmula oficial",
  "player.stats.coachRating": "Nota do Treinador",
  "player.stats.attitude": "Atitude",
  "player.stats.hitsVsMisses": "Acertos vs Erros",
  "player.stats.shotsOnTarget": "Chutes no gol / total",
  "player.stats.duelsWon": "Duelos ganhos / total",
  "player.stats.recoveriesLosses": "Recuperações vs Perdas",
  "player.stats.fouls": "faltas",
  "player.stats.bestStat": "Seu melhor dado nesta partida",
  "player.stats.youVsAverage": "Você vs sua média de temporada",
  "player.stats.areasPending": "Áreas pendentes de medição",
  "player.stats.activeDiscomfort": "Desconforto ativo",
  "player.stats.available100": "100% Disponível",
  "player.stats.dailyProgression": "Evolução Diária (Últimos 7 check-ins)",
  "player.stats.pain": "Dor",
  "player.stats.ok": "OK",
  "player.stats.cleanSheet": "Jogos sem sofrer gols",
  "player.chat.defaultPlayerName": "este jogador",
  "player.home.defaultRole": "Jogador",
  "player.home.defaultCrack": "Craque",
  "player.home.calledUpSquad": "Você está na convocação oficial desta partida!",
  "player.home.defaultLocation": "Campo de Treinamento",
  "stats.singleMatch": "1 partida",
  "stats.partidos": "partidas",
  "player.home.staffAuthor": "Comissão Técnica",
  "player.home.recent": "Recente",
  "player.banner.perfProfile": "PERFIL DE RENDIMENTO",
  "player.banner.noTestData": "Sem avaliações ainda",
  "player.banner.perfMedal": "MEDALHA DE RENDIMENTO",
  "player.profile.securityReauth": "Por motivos de segurança, você deve sair e entrar novamente antes de excluir sua conta.",
  "player.profile.deleteAccountError": "Não foi possível excluir a conta. Entre em contato ou tente novamente após reiniciar a sessão.",
  "player.profile.matchesPlayedShort": "PJ",
  "player.profile.defaultCategory": "Juvenil",
  "player.profile.accountFallback": "Conta de Jogador",
  "player.wellness.saving": "Salvando...",
  "player.consent.parentPlaceholder": "Ex. Carlos Caicedo Silva",
  "player.settings.notifDenied": "Permissões de notificação negadas.",
  "player.settings.remindersActivated": "Lembretes ativados.",
  "player.settings.languageUpdated": "Idioma atualizado",
  "player.settings.confirmLogout": "Deseja encerrar a sessão?",
  "player.settings.toggleTheme": "Alternar tema claro/escuro",
  "player.settings.toggleNotif": "Alternar notificações",
  "test.name.cooper": "Teste de Cooper",
  "test.cat.endurance": "Físico · Resistência",
  "test.name.navette": "Course Navette",
  "test.name.sprint10": "Sprint 10m",
  "test.cat.speed": "Físico · Velocidade",
  "test.name.sprint30": "Sprint 30m",
  "test.name.ttest": "T-Test (Agilidade)",
  "test.cat.agility": "Físico · Agilidade",
  "test.name.cmj": "Salto CMJ",
  "test.cat.power": "Físico · Força",
  "test.name.cones": "Condução cones",
  "test.cat.ballControl": "Técnica · Controle",
  "test.name.shooting": "Passe ao gol",
  "test.cat.accuracy": "Técnica · Precisão",
  "test.name.acsi28": "ACSI-28 (Enfrentamento)",
  "test.cat.pressure": "Mental · Pressão",
  "test.name.mtq10": "MTQ-10 (Força Mental)",
  "test.cat.resilience": "Mental · Resiliência",
  "test.name.goals": "Estabelecimento de Metas",
  "test.cat.goals": "Mental · Metas",
  "test.name.leadership": "Liderança e Comunicação",
  "test.cat.leadership": "Mental · Liderança",
  "test.name.geq": "GEQ (Coesão de Equipe)",
  "test.cat.cohesion": "Social · Coesão",
  "test.name.mhc": "Escala Bem-estar Mental",
  "test.cat.wellbeing": "Mental · Bem-estar",
  "test.name.emotions": "Autoconsciência Emocional",
  "test.cat.emotions": "Mental · Emoções",
  "player.stats.pendingOfficialSheet": "Pendente de confirmação oficial — Os dados aparecerão quando a comissão fechar a súmula.",
  "stats.goles": "Gols",
  "stats.asistencias": "Assist.",
  "stats.minutos": "Minutos",
  "player.stats.goalsThisMatch": "Gols nesta partida",
  "player.stats.minutesThisMatch": "Minutos nesta partida",
  "player.stats.avgShort": "média",
  "player.stats.avgLabel": "Média",
  "player.stats.coachMessage": "Mensagem do Treinador",
  "player.stats.discipline": "Disciplina",
  "player.stats.lastEval": "Última avaliação:",
  "player.tab.technical": "Técnica",
  "player.tab.tactical": "Tática",
  "player.stats.trainingRatingDesc": "Nota técnica em sessões de treinamento",
  "player.stats.pendingRatings": "Pendente de avaliações",
  "player.stats.noRatingsYet": "Sem avaliações de treinamento ainda",
  "player.stats.ratingsInfoDesc": "A comissão técnica pode avaliar o rendimento e registrar notas técnicas após cada treino pelo módulo de Sessões.",
  "player.stats.weeklyWellness": "BEM-ESTAR E RECUPERAÇÃO SEMANAL",
  "player.stats.last7Days": "Últimos 7 dias",
  "player.stats.sleepQuality": "QUALIDADE DO SONO",
  "player.stats.energyMood": "ENERGIA / DISPOSIÇÃO",
  "player.stats.muscleStatus": "ESTADO MUSCULAR",
  "player.profile.sectionsAria": "Seções do perfil do jogador",
  "player.banner.viewFullAnalytics": "Ver análises completas",
  "player.banner.techSummary": "Resumo técnico",
  "player.banner.renewTests": "Renovar questionários e testes",
  "player.wellness.synced": "Sincronizado",
  "player.wellness.offlinePending": "Sincronização pendente",
  "games.level.bronce": "Bronze",
  "games.level.plata": "Prata",
  "games.level.oro": "Ouro",
  "games.level.diamante": "Diamante",
  "games.level.leyenda": "Lenda",
  "games.levelUp": "Você subiu para o nível {level}! (+10 XP)",
  "games.levelCeiling": "Você atingiu o topo de Lenda!",
  "games.g3.opponent": "Adversário",
  "games.g3.teammate": "Companheiro",
  "exercise.level": "Nível"
};

export default pt;
